{
  "common": {
    "appTitle": "Draughts MVP",
    "back": "Zurück",
    "exit": "Beenden",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "continue": "Weiter",
    "copy": "Kopieren",
    "error": "Fehler",
    "loading": "Laden...",
    "retry": "Wiederholen",
    "or": "oder",
    "vs": "vs",
    "you": "Du",
    "anonymous": "Anonym",
    "send": "Senden",
    "download": "Herunterladen",
    "noLimit": "Kein Limit",
    "comingSoon": "Demnächst",
    "version": "v{{version}}",
    "enabled": "Aktiviert",
    "disabled": "Deaktiviert",
    "apply": "Übernehmen",
    "errorBoundary": "Etwas ist schiefgelaufen. Versuche neu zu laden: wenn gerade eine neue Version erschienen ist, wird sie geladen.",
    "dismissNotice": "Schließen"
  },
  "errors": {
    "loadFailed": "Diese Daten konnten nicht geladen werden. Versuche es erneut.",
    "network": "Keine Internetverbindung. Prüfe dein Netzwerk und versuche es erneut.",
    "notFound": "Diese Seite existiert nicht (mehr)."
  },
  "senzaRete": {
    "titolo": "Du bist offline",
    "dati": "Diese Seite kann ihre Daten erst laden, wenn die Verbindung zurück ist.",
    "home": "Online-Partien, Turniere und die Rangliste sind nicht verfügbar. Du kannst trotzdem gegen den Computer oder zu zweit an diesem Gerät spielen."
  },
  "avvisoServizio": {
    "etichetta": "Servicehinweis",
    "preset": {
      "riavvio": "Geplanter Neustart: Der Server ist für einen Moment nicht erreichbar. Laufende Partien gehen nicht verloren.",
      "riavvioAlle": "Geplanter Neustart um {{ora}}: Der Server ist für einen Moment nicht erreichbar. Laufende Partien gehen nicht verloren.",
      "manutenzione": "Wartung läuft: Einige Funktionen sind möglicherweise nicht verfügbar.",
      "manutenzioneAlle": "Wartung ab {{ora}}: Einige Funktionen sind möglicherweise nicht verfügbar.",
      "rallentamenti": "Der Server ist langsamer als gewöhnlich. Wir arbeiten daran."
    }
  },
  "nav": {
    "play": "Spielen",
    "tournaments": "Turniere",
    "leaderboard": "Rangliste",
    "myGames": "Meine Spiele",
    "logout": "Abmelden",
    "signIn": "Anmelden",
    "backToLocal": "Zurück zum Lokalen Spiel",
    "backToTournaments": "Zurück zu Turnieren",
    "backToGames": "Zurück zu Spielen",
    "home": "Home",
    "arena": "Arena",
    "profile": "Profil",
    "loginRequired": "Anmeldung erforderlich",
    "faq": "FAQ & Kontakt",
    "rules": "Regeln",
    "editor": "Editor",
    "strumenti": "Tools"
  },
  "gara": {
    "torneoInCorso": "Turnier läuft",
    "arenaInCorso": "Arena läuft"
  },
  "strumenti": {
    "titoloFoglio": "Tools (Werkzeuge)",
    "orologio": "Uhr",
    "estraiApertura": "Eröffnung ziehen"
  },
  "orologio": {
    "titolo": "Brettuhr",
    "sottotitolo": "Legen Sie das Telefon zwischen die Spieler: wer gezogen hat, tippt auf seine Hälfte",
    "tocca": "Zum Starten tippen",
    "pausa": "Pause",
    "riprendi": "Fortsetzen",
    "azzera": "Zurücksetzen",
    "impostazioni": "Einstellungen",
    "suoni": "Töne",
    "suonoTocco": "Ton beim Tippen",
    "suonoPocoTempo": "Ton bei wenig Zeit",
    "tempo": "Zeit",
    "stessoTempo": "Gleiche Zeit für beide",
    "scaduto": "Zeit abgelaufen",
    "mosse": "Züge"
  },
  "apertura": {
    "sottotitolo": "Ziehen Sie eine offizielle Eröffnung",
    "andataRitorno": "Diese Eröffnung kann eine Farbe begünstigen: im Wettkampf wird sie mit Hin- und Rückspiel und getauschten Farben gespielt.",
    "estrai": "Ziehen",
    "estraiDiNuovo": "Neu ziehen",
    "vediTabelle": "Alle Tabellen ansehen",
    "posizioneIniziale": "Grundstellung"
  },
  "editor": {
    "title": "Editor",
    "subtitle": "Stelle eine Position zum Studieren, Analysieren oder Spielen auf",
    "boardLabel": "Bearbeitbares Brett",
    "sideToMove": "Am Zug",
    "reset": "Reset",
    "clear": "Leeren",
    "flip": "Drehen",
    "playPosition": "Position spielen",
    "playAI": "Gegen Computer spielen",
    "challenge": "Freund herausfordern",
    "challengeNote": "Die Partie beginnt aus deiner Position und ist immer freundschaftlich (ohne Wertung).",
    "tools": {
      "label": "Steine",
      "whiteMan": "Weißer Stein",
      "whiteKing": "Weiße Dame",
      "blackMan": "Schwarzer Stein",
      "blackKing": "Schwarze Dame",
      "erase": "Löschen",
      "cycle": "Stein wechseln"
    },
    "library": {
      "open": "Gespeicherte Stellungen",
      "title": "Gespeicherte Stellungen",
      "nameLabel": "Name",
      "namePlaceholder": "Name der Stellung",
      "defaultName": "Stellung",
      "defaultNameAnalysis": "Analyse",
      "save": "Speichern",
      "overwrite": "Überschreiben",
      "willOverwrite": "„{{name}}“ wird ersetzt.",
      "saved": "In deiner Bibliothek",
      "empty": "Noch keine gespeicherten Stellungen. Stelle eine Position zusammen und speichere sie hier.",
      "load": "{{name}} laden",
      "lineBadge_one": "{{count}} Zug",
      "lineBadge_other": "{{count}} Züge",
      "askLoad": "„{{name}}“ laden? Die Stellung auf dem Brett wird ersetzt.",
      "askLoadLine": "„{{name}}“ laden? Die Stellung und die gespielte Variante werden ersetzt.",
      "confirmLoad": "Laden",
      "rename": "{{name}} umbenennen",
      "share": "{{name}} teilen",
      "shareCopied": "Link kopiert",
      "shareTitle": "Dame-Stellung",
      "shareText": "Sieh dir diese Dame-Stellung an",
      "delete": "{{name}} löschen",
      "askDelete": "„{{name}}“ löschen?",
      "confirmDelete": "Löschen",
      "errors": {
        "nameTaken": "Eine Stellung mit diesem Namen existiert bereits.",
        "full": "Bibliothek voll: Lösche eine Stellung, um eine neue zu speichern.",
        "saveFailed": "Speichern fehlgeschlagen. Bitte erneut versuchen.",
        "deleteFailed": "Löschen fehlgeschlagen. Bitte erneut versuchen.",
        "loadFailed": "Diese Stellung kann nicht gelesen werden.",
        "loadListFailed": "Die Bibliothek konnte nicht geladen werden.",
        "shareFailed": "Der Link konnte nicht kopiert werden."
      }
    },
    "fen": {
      "label": "Stellung (FEN)",
      "copy": "FEN kopieren",
      "copied": "Kopiert",
      "invalid": "Ungültiges FEN."
    },
    "analysis": {
      "title": "Analyse",
      "hint": "Ziehe beide Farben. Gehe zurück und spiele einen anderen Zug, um die Variante zu ändern.",
      "save": "Analyse speichern",
      "run": "Analysieren",
      "depth": "Tiefe",
      "fast": "Schnell",
      "standard": "Standard",
      "deep": "Tief",
      "evaluation": "Bewertung",
      "cancel": "Abbrechen",
      "reached": "Erreichte Tiefe"
    },
    "invalid": {
      "noWhite": "Füge mindestens einen weißen Stein hinzu.",
      "noBlack": "Füge mindestens einen schwarzen Stein hinzu.",
      "manOnPromotionRow": "Ein Stein darf nicht auf seiner Umwandlungsreihe stehen — mach ihn zur Dame oder verschiebe ihn.",
      "tooManyPieces": "Zu viele Steine für diese Variante.",
      "sideToMoveNoMoves": "Die Seite am Zug hat keine legalen Züge.",
      "alreadyTerminal": "Diese Stellung ist bereits entschieden (gewonnen oder remis).",
      "offBoard": "Ein Stein steht auf einem Feld, das es in dieser Variante nicht gibt.",
      "duplicateSquare": "Zwei Steine auf demselben Feld."
    }
  },
  "rules": {
    "channels": {
      "cta": "Empfohlene Kanäle",
      "title": "Empfohlene Kanäle",
      "note": "Kanäle, die wir zum Anschauen und Studieren dieser Variante empfehlen.",
      "opensOnYouTube": "Wird auf YouTube geöffnet"
    },
    "backToRules": "Alle Regeln",
    "playOnline": "Jetzt spielen",
    "playAI": "Gegen Computer spielen",
    "indexTitle": "Dame-Regeln",
    "indexIntro": "Zwei Regelwerke an einem Ort: die Spielregeln jeder unterstützten Variante und die Regeln, nach denen unsere Online-Turniere laufen.",
    "gameTitle": "Dame-Regeln nach Variante",
    "gameIntro": "Dame — auch bekannt als draughts, checkers, dama und dammen — wird auf der ganzen Welt gespielt, jede Region mit eigenen Regeln. Durchstöbere unten die Regeln jeder unterstützten Variante.",
    "gameCtaDesc": "Brett, Züge, Schlagen und Umwandlung — Variante für Variante.",
    "heroSubtitle": "Regeln, Aufstellung und wie man {{variant}} spielt.",
    "startingPosition": "Grundstellung",
    "howToPlay": "Spielanleitung",
    "otherVariants": "Andere Varianten",
    "eyebrow": "Regeln",
    "glance": {
      "title": "Auf einen Blick",
      "board": "Brett",
      "pieces": "Steine pro Seite",
      "starts": "Erster Zug"
    },
    "theme": {
      "movement": "Zug",
      "capture": "Schlagen",
      "promotion": "Umwandlung"
    },
    "variantsLabel": "Varianten",
    "draughtsWord": "Dame",
    "tournaments": {
      "title": "Turnierregeln",
      "heroSubtitle": "Alles, was ein Turnier selbst entscheidet, von der Rundenzahl bis zur Feinwertung.",
      "intro": "Sobald es begonnen hat, läuft ein Turnier von allein: Es zählt die anwesenden Teilnehmer, wählt das Paarungssystem, legt die Rundenzahl fest und erstellt die Tabelle. Das sind die Regeln, die es anwendet, in genau dieser Reihenfolge.",
      "source": "Quelle: FIDE C.04.1 und FMJD Annex 3, an das Onlinespiel angepasst.",
      "cta": "Wie ein Turnier abläuft",
      "ctaDesc": "Turnierform, Runden, Anmeldung, Abwesenheit, Feinwertung und die Arena.",
      "chaptersLabel": "Kapitel",
      "format": {
        "title": "Turnierform",
        "body": [
          "Nur ein Format mit Runden, das System Rundenturnier/Schweizer: Wer ein Turnier eröffnet, wählt nicht zwischen Rundenturnier und Schweizer System, sondern eine Teilnehmerschwelle. Neben den Turnieren gibt es die Arena, und das ist etwas anderes: siehe das Kapitel „Die Arena“.",
          "Zur Startzeit werden die tatsächlich Angemeldeten gezählt. Unterhalb der Schwelle wird ein Rundenturnier gespielt: jeder gegen jeden, nach den Berger-Tabellen. Ab der Schwelle wird nach Schweizer System gespielt: In jeder Runde wird man mit Spielern der eigenen Punktzahl gepaart, und niemand spielt zweimal gegen denselben Gegner.",
          "Die Standardschwelle ist 7 und lässt sich zwischen 7 und 20 einstellen; ein Rundenturnier fasst höchstens 19 Teilnehmer.",
          "Der Grund ist einfach: Beim Eröffnen eines Turniers weiß niemand, wie viele kommen, und das Format vorher zu wählen hieße, es blind zu wählen.",
          "Sieg 2 Punkte, Remis 1 Punkt, Niederlage keiner. Bei ungerader Teilnehmerzahl setzt in jeder Runde einer aus, und was dieses Freilos wert ist, hängt vom Format ab: im Schweizer System bringt es 2 Punkte wie ein Sieg — 4 in einem Turnier mit Hin- und Rückspiel, wo jede Runde zwei Partien sind —, im Rundenturnier dagegen keinen einzigen, denn dort spielt jeder gegen jeden und das Freilos ist nur eine Runde, die nicht gespielt wird. In beiden Fällen zählt es nicht als gewonnene Partie und geht nicht in die Wertungen ein."
        ]
      },
      "rounds": {
        "title": "Anzahl der Runden",
        "body": [
          "Das legt der Turnierstart fest, anhand der anwesenden Teilnehmer. Mit der Standardschwelle, nach Teilnehmerzahl:",
          "Ein Turnier fasst höchstens 200 Teilnehmer, zehn Runden sind also das Maximum — elf mit der Zusatzrunde.",
          "Im Rundenturnier sind es so viele, wie nötig sind, damit jeder gegen jeden spielt. Bei drei oder vier Teilnehmern wird immer mit Hin- und Rückspiel gespielt, unabhängig davon, was beim Erstellen gewählt wurde: jede Runde besteht dann aus zwei Partien, denn bei nur einer Partie pro Gegner würde eine Niederlage in der ersten Runde das Turnier bereits entscheiden. Mit vier Teilnehmern sind es drei Runden und sechs Partien pro Person; mit drei werden dieselben drei Runden gespielt, aber jedes Mal setzt einer aus, also ruht jeder einmal und spielt vier Partien — und die Freirunde bringt keine Punkte.",
          "Im Schweizer System kommt bei jeder Verdopplung des Feldes eine Runde hinzu: Jede Runde halbiert die Zahl derer, die noch mit voller Punktzahl enden können. Es ist eine Runde mehr, als ein K.-o.-Turnier bräuchte, denn sonst könnten zwei Spieler gleichauf an der Spitze landen, ohne je gegeneinander gespielt zu haben.",
          "Zwei Schalter ändern die Rechnung. «Zusatzrunde» legt eine auf die Tabelle drauf, wenn das Feld sie trägt, und greift nur, wenn der Start ein Schweizer System ergibt: Im Rundenturnier trifft ohnehin jeder auf jeden, und eine Runde mehr wäre nur eine Revanche für alle. «Hin- und Rückspiel» fügt dagegen keine Runden hinzu, sondern füllt sie: Jede Paarung wird zweimal hintereinander gespielt, mit vertauschten Farben und auf derselben Eröffnung, innerhalb derselben Runde, die damit doppelt so lange dauert. Es funktioniert im Rundenturnier und im Schweizer System gleich, und die Punkte bleiben pro Partie: Ein Sieg und ein Remis ergeben 3, zwei Siege 4."
        ],
        "rounds": [
          "3-4 — Rundenturnier, 3 Runden",
          "5-6 — Rundenturnier, 5 Runden",
          "7-8 — Schweizer, 4 Runden",
          "9-16 — Schweizer, 5 Runden",
          "17-32 — Schweizer, 6 Runden",
          "33-64 — Schweizer, 7 Runden",
          "65-128 — Schweizer, 8 Runden",
          "129-192 — Schweizer, 9 Runden",
          "193-200 — Schweizer, 10 Runden"
        ]
      },
      "entry": {
        "title": "Anmeldung und Rückzug",
        "body": [
          "Eröffnen darf jeder mit einem registrierten Konto: Es braucht keine Erlaubnis, und es gibt keinen offiziellen Veranstalter. Gäste und Computer kommen nicht in Turniere, weder zum Eröffnen noch zum Spielen.",
          "Drei laufende Wettbewerbe pro Person: Du kannst bis zu drei Turniere oder Arenen gleichzeitig offen halten; für einen weiteren musst du warten, bis einer endet, oder ihn absagen.",
          "Ein Turnier wird geplant, nicht von Hand gestartet: Der Beginn liegt zwischen fünf Minuten und vierzehn Tagen in der Zukunft. Wer es eröffnet, organisiert es nur: Zum Mitspielen muss er auf der Turnierseite «Teilnehmen» drücken wie alle anderen, und solange er das nicht tut, zählt er nicht mit — ein Minimum von 3 verlangt drei Personen außer ihm.",
          "Die Plätze reichen von 3 bis 200. Das Minimum zum Start ist 3, und wer eröffnet, darf es anheben: Sind zur Startzeit weniger Teilnehmer da als das Minimum, sagt sich das Turnier selbst ab. Solange es nicht begonnen hat, kann der Veranstalter es absagen; danach nicht mehr, denn wer spielt, hat ein Recht darauf, zu Ende zu spielen.",
          "Ein Turnier kann privat sein: Hinein kommt man nur mit dem Passwort, das der Veranstalter gewählt hat, oder mit dem Einladungslink.",
          "Anmelden kann man sich, bis die erste Runde beginnt, und bis dahin kann man auch wieder austreten — wer vor dem Start absagt, verschwindet sofort aus der Tabelle, denn es wurde noch nichts gespielt. Danach schließt sich die Tür in beide Richtungen: Wer drin ist, bleibt in der Auslosung, denn ein Austritt auf halbem Weg ließe in jeder verbleibenden Runde einen Gegner ohne Partie."
        ]
      },
      "absences": {
        "title": "Abwesenheit",
        "body": [
          "Das hängt davon ab, wo du warst, und die drei Fälle enden unterschiedlich.",
          "Bist du einfach offline, wird die Partie trotzdem eröffnet und deine Uhr läuft. Drei Minuten zu spät zu kommen heißt, mit drei Minuten weniger zu spielen, nicht die Partie zu verlieren: Nur wenn du nie kommst, verlierst du auf Zeit. Eine Partie, an die sich einer der beiden nie gesetzt hat, bewegt bei niemandem die Wertung.",
          "Dasselbe gilt, wenn du verbunden bist und die Verbindung vor deinem ersten Zug abbricht: deine Uhr entscheidet. Nach dem ersten Zug hast du bei einem Abbruch 30 Sekunden, um zurückzukommen, wie in jeder Partie.",
          "Bist du dagegen schon in einer anderen Partie beschäftigt — einer Arena, einer Herausforderung, einem anderen Turnier —, wird die Partie der Runde gar nicht erst eröffnet und du bekommst eine kampflose Niederlage, die 2 Punkte gehen an deinen Gegner. Das ist keine Strafe: Dir ein zweites Brett zu öffnen, würde das Brett unerreichbar machen, an dem du bereits spielst.",
          "Fehlt ihr zu zweit, endet die Runde 0-0 und niemand bekommt etwas. Ein Remis am grünen Tisch würde die Abwesenheit belohnen.",
          "In keinem der drei Fälle fliegt man raus: In der nächsten Runde wird man wie immer gepaart.",
          "Eines gilt für alle: Ein Turnier hat eine angekündigte Dauer, und laufen zu dieser Zeit noch Partien, bekommen sie zehn Minuten. Danach schließt das Turnier, und die noch offenen Partien werden als Remis gewertet."
        ]
      },
      "openingMoves": {
        "title": "Eröffnungszüge",
        "body": [
          "Das hängt davon ab, wie das Turnier eröffnet wurde, und es gibt neun Möglichkeiten.",
          "«Freier Zug» ist der normale: Es wird vom ersten Zug an gespielt, und nichts wird vorgegeben.",
          "Dann kommen die Auslosungen. Drei davon setzen einen, zwei oder drei zufällige regelkonforme Züge und gelten für jede Variante. Vier weitere losen aus einer offiziellen F.I.D.-Tabelle und gibt es nur bei Italienisch und Englisch, den beiden Varianten mit einer Verbandstabelle: Gewählt wird dort, wie unausgewogen die herauskommende Eröffnung sein darf — bis 1N/1B, bis 2N/2B, bis 3N/3B oder alle 174. Im Schweizer System kommt dieselbe Eröffnung in einem Turnier nie zweimal vor.",
          "Und dann gibt es das Thementurnier: Wer eröffnet, wählt EINE der 174 offiziellen Eröffnungen, und alle spielen sie, in allen Runden und allen Partien. Es ist der einzige Fall, in dem die Eröffnung schon vor Beginn bekannt ist, und der einzige, in dem die Regel «nie zweimal dieselbe» nicht gilt — das wäre genau das Gegenteil dessen, was ein Thementurnier verlangt.",
          "Mit Hin- und Rückspiel werden die beiden Partien einer Runde auf derselben Eröffnung mit vertauschten Farben gespielt: So hört eine unausgewogene Eröffnung auf, jemanden zu bevorzugen."
        ]
      },
      "rated": {
        "title": "Gewertete Turniere",
        "body": [
          "Wenn das Turnier gewertet wird, ja — und nicht in einer eigenen Liste: Turnierpartien bewegen dieselbe Wertung wie alle anderen Partien, die der gespielten Variante und Bedenkzeit. Wer das Turnier eröffnet, entscheidet darüber, und standardmäßig wird gewertet.",
          "Ein gewertetes Turnier oder eine gewertete Arena kann eine Mindestwertung haben, also eine Untergrenze für die Teilnahme, in Stufen von 1000 bis 2000: Gemessen wird sie an deiner Wertung für diese Variante und diese Bedenkzeit, nicht an einer allgemeinen. Bei freundschaftlichen Wettbewerben gibt es sie nicht, denn die Wertung bewegt sich nicht und es ist nichts zu schützen. Eine Obergrenze gibt es nicht: Niemand bleibt draußen, weil er zu stark ist.",
          "Eines kann die Wertung von selbst abschalten, und das ist die Eröffnung. Die Verbandsregel besagt, dass eine einzelne Partie genügt, solange die Eröffnung bis 2N/2B reicht; darüber ist der Vorteil einer Farbe zu groß, als dass eine einzelne Partie ihn ausgleichen könnte, und es braucht Hin- und Rückspiel. Das gilt in beiden Fällen: Bei einer Auslosung zählt die Obergrenze der Tabelle, aus der gelost wird, bei einem Thementurnier zählt die Stärke der gewählten Eröffnung, die dort bereits bekannt ist. Hält die Kombination nicht, entsteht das Turnier freundschaftlich statt abgelehnt zu werden — und Hin- und Rückspiel einzuschalten macht es wieder gewertet.",
          "Nicht gewertet werden schließlich Partien, an die sich einer der beiden nie gesetzt hat."
        ]
      },
      "tiebreaks": {
        "title": "Feinwertung",
        "body": [
          "Das hängt vom Format ab.",
          "Im Schweizer System, in dieser Reihenfolge:",
          "1. Buchholz Cut 1: die Summe der Endpunkte aller Gegner, ohne den schwächsten. Belohnt den schwereren Weg. Ein Freilos zählt nicht mit, denn es ist kein Gegner.",
          "2. Sonneborn-Berger: die Punkte der besiegten Gegner plus die Hälfte der Punkte der Remisgegner. Belohnt den, der die Stärkeren geschlagen hat.",
          "3. Die Zahl der Siege.",
          "4. Die Ratingänderung im Turnier: wie viele Ratingpunkte du in den Partien dieses Turniers gewonnen oder verloren hast. Sie belohnt, wer besser als erwartet gespielt hat, nicht wer schon vorher stärker war. Wer auch hier gleich ist, teilt sich den Platz.",
          "Buchholz und Sonneborn-Berger stehen in der Tabelle nach Siegen, Remis, Niederlagen und Freilosen, abgekürzt als BH und SB.",
          "Im Rundenturnier gelten andere Kriterien, weil jeder gegen jeden spielt und Buchholz niemanden trennen würde: zuerst die Zahl der Siege, dann der direkte Vergleich unter den punktgleichen Spielern, dann Sonneborn-Berger (SB), zuletzt die Ratingänderung im Turnier. Wer danach immer noch gleichauf liegt, wird nach der Startnummer im Turnierplan gereiht, also nach der höheren Wertungszahl zu Turnierbeginn: Im Rundenturnier gibt es keine geteilten Plätze. BH wird dort gar nicht angezeigt, denn wenn jeder gegen jeden spielt, ist es nur das Spiegelbild der Punkte. In der Tabelle steht «DV» bei dem, der durch den direkten Vergleich vorn liegt."
        ]
      },
      "sharedPlaces": {
        "title": "Geteilte Plätze",
        "body": [
          "Im Schweizer System kommt das in kleinen Turnieren vor, wenn alle Partien remis enden: gleiche Punkte, gleicher Buchholz, gleicher Sonneborn-Berger, kein einziger Sieg.",
          "Dann wird der Platz geteilt. Zwei punktgleiche Erste bekommen beide Gold, und der nächste Platz ist der dritte: 1, 1, 3, wie in jeder Sporttabelle. Niemand wird wegen seiner Wertungszahl oder wegen der früheren Anmeldung vorgezogen.",
          "Ein Vorbehalt: In der Turnierchronik bleibt ein einziger Name als Sieger stehen, denn dieses Feld fasst nur einen. Tabelle und Podium zeigen alle Punktgleichen."
        ]
      },
      "arena": {
        "title": "Die Arena",
        "body": [
          "Der andere Wettbewerb, den man eröffnen kann, und er ist kein Turnier mit Runden: Er hat weder Runden noch einen Spielplan, er hat eine Dauer. Er öffnet, läuft von zehn Minuten bis acht Stunden, und solange er offen ist, wird man neu gepaart, sobald man fertig ist, ohne zu warten, bis die anderen ihre Partie beenden. Man kommt und geht, wie man will, auch wenn er schon läuft.",
          "Mit derselben Person wartet man allerdings: fünf Minuten für jede bereits miteinander gespielte Partie. Die erste Revanche kommt nach fünf Minuten, die zweite nach zehn, die dritte nach fünfzehn, und eine Obergrenze gibt es nicht. So wird aus einer Arena nicht dieselbe Begegnung endlos wiederholt.",
          "Punkte: Sieg 2, Remis 1, Niederlage keiner, wie im Turnier.",
          "Und es gibt den Boost, zu nehmen vor dem eigenen ersten Zug: Er verdoppelt die Punkte eines Sieges und wird mit der Uhr bezahlt — das Inkrement fällt ganz weg, und die Grundzeit wird halbiert. Es ist eine Wette, kein Geschenk.",
          "Bei Punktgleichheit zählt, wer mehr Partien gewonnen hat."
        ]
      }
    },
    "seo": {
      "title": "{{variant}}: Regeln und Spielanleitung",
      "description": "Lerne die Regeln von {{variant}}: Brettgröße, Grundstellung, wie Steine und Damen ziehen und schlagen, und wie man gewinnt. Spiele {{draughtsWord}} kostenlos online.",
      "indexTitle": "Dame-Regeln — Spielregeln und Turnierregeln",
      "indexDescription": "Zwei Regelwerke für {{draughtsWord}}: die Spielregeln jeder Variante — International, Italienisch, Türkisch, Friesisch und mehr — und die Regeln unserer Online-Turniere.",
      "gameTitle": "Dame-Regeln nach Variante — Spielanleitung",
      "gameDescription": "Regeln und Anleitungen für jede Variante von {{draughtsWord}}: International, Italienisch, Türkisch, Friesisch, Brasilianisch und viele mehr. Kostenlos online spielen.",
      "openingsTitle": "{{variant}}: offizielle F.I.D.-Eröffnungstabellen",
      "openingsDescription": "Alle 174 offiziellen Eröffnungen von {{variant}} mit Bewertung und den Verbandstabellen A, B, C und D. F.I.D. Regolamento Tecnico 2025.",
      "captureTitle": "{{variant}}: alle Schlagregeln",
      "captureDescription": "Alle Schlagregeln von {{variant}}: Schlagzwang, Mehrfachschlag, die Rangfolge, die den Pflichtschlag bestimmt, und Umwandlung. Mit Beispielen auf dem Brett.",
      "tournamentsTitle": "Turnierregeln — wie ein {{draughtsWord}}-Turnier abläuft",
      "tournamentsDescription": "Die Regeln der Online-{{draughtsWord}}-Turniere: Form Rundenturnier/Schweizer, Rundenzahl, Anmeldung und Rückzug, Abwesenheit, Eröffnungsauslosung, Wertung, Feinwertung und die Arena."
    },
    "fact": {
      "board": "Gespielt auf einem {{size}}×{{size}}-Brett, nur auf den dunklen Feldern.",
      "boardAllSquares": "Gespielt auf einem {{size}}×{{size}}-Brett, auf allen Feldern.",
      "pieces": "Jeder Spieler beginnt mit {{count}} Steinen.",
      "startsWhite": "Weiß zieht zuerst.",
      "startsBlack": "Schwarz zieht zuerst.",
      "moveDiagonal": "Steine ziehen diagonal vorwärts, ein Feld pro Zug.",
      "moveOrthogonal": "Steine ziehen orthogonal — vorwärts und seitwärts — ein Feld pro Zug.",
      "captureDiagonal": "Geschlagen wird diagonal, indem über einen benachbarten gegnerischen Stein gesprungen wird.",
      "captureOrthogonal": "Geschlagen wird orthogonal, indem über einen benachbarten gegnerischen Stein gesprungen wird.",
      "captureMixed": "Geschlagen werden kann sowohl diagonal als auch orthogonal.",
      "menCaptureBackwardYes": "Steine dürfen vorwärts und rückwärts schlagen.",
      "menCaptureBackwardNo": "Steine dürfen nur vorwärts schlagen.",
      "kingFlying": "Damen sind \"fliegend\": Sie ziehen und schlagen über beliebig viele leere Felder entlang einer Linie.",
      "kingShort": "Damen ziehen ein Feld pro Zug (keine fliegenden Damen).",
      "menCaptureKingYes": "Steine dürfen Damen schlagen.",
      "menCaptureKingNo": "Steine dürfen keine Damen schlagen.",
      "maxCapturePieces": "Schlagen ist Pflicht, und man muss die Folge wählen, die die meisten Steine schlägt.",
      "maxCaptureValue": "Das Schlagen ist Pflicht und es muss die wertvollste Folge gewählt werden: eine Dame ist mehr wert als ein Stein, aber zwei Steine sind mehr wert als eine Dame.",
      "captureMandatoryFree": "Schlagen ist Pflicht, aber man darf frei wählen, welchen Schlag man ausführt.",
      "kingPriorityTie": "Bei ansonsten gleichwertigen Schlägen muss mit einer Dame geschlagen werden, nicht mit einem Stein.",
      "maxKingsCaptureTie": "Bei gleicher Steinzahl muss die Folge gespielt werden, die die meisten Damen schlägt.",
      "firstKingFirst": "Bleibt es weiterhin gleich, muss die Folge gewählt werden, die am frühesten eine Dame schlägt.",
      "huffing": "Die \"Blas\"-Regel gilt: Ein Stein, der nicht geschlagen hat, kann entfernt werden.",
      "captureImmediateRemoval": "Jeder geschlagene Stein wird sofort vom Brett entfernt; dadurch können sich in derselben Schlagfolge weitere Schläge ergeben.",
      "captureNoReversal": "Bei einem Mehrfachschlag darf man geradeaus weiterziehen oder um 90° abbiegen, aber nie um 180° zwischen zwei Sprüngen umkehren.",
      "promotionStops": "Ein Stein, der die letzte Reihe erreicht, wird zur Dame und der Zug endet, auch mitten im Schlag.",
      "promotionContinues": "Ein Stein, der beim Schlagen über die letzte Reihe zieht, bleibt Stein und schlägt weiter; er wird nur zur Dame, wenn der Zug auf der letzten Reihe endet.",
      "promotionInPassing": "Ein Stein, der beim Schlagen die letzte Reihe erreicht, wird sofort zur Dame und schlägt im selben Zug als fliegende Dame weiter.",
      "blockedKing": "Solange ein Spieler noch Steine hat, darf er nicht mehr als {{n}} aufeinanderfolgende einfache Züge mit derselben Dame machen; die gesperrte Dame darf aber schlagen.",
      "frisianEndgame": "Friesische Endspiel-Remisregeln gelten (z. B. zwei Damen gegen eine ist nach einer festgelegten Zugzahl remis).",
      "loneKingWins": "Bleibt einem Spieler nur ein einzelner Stein gegen die Dame des Gegners, wird die Seite mit der Dame zum Sieger erklärt.",
      "singlePieceLoses": "Wer nur noch einen einzigen Stein hat — Stein oder Dame — verliert sofort die Partie.",
      "drawLimit": "Die Partie endet remis nach {{n}} Zügen, in denen nur Damen ziehen und nichts geschlagen wird."
    },
    "openings": {
      "title": "Eröffnungstabellen",
      "heroSubtitle": "Die 174 offiziellen Eröffnungen von {{variant}}, mit Bewertung und zugehöriger Verbandstabelle.",
      "source": "Quelle: Regolamento Tecnico F.I.D., Januar 2025.",
      "cta": "Eröffnungstabellen",
      "ctaDesc": "Die 174 offiziellen Eröffnungen und ihre Bewertung.",
      "intro": "In offiziellen Wettkämpfen werden die ersten drei Halbzüge nicht gewählt, sondern aus einer Tabelle ausgelost. Die Generaltabelle enthält alle 174 Eröffnungen; die Verbandstabellen A, B, C und D sind Teilmengen davon, je nach Art des Wettkampfs.",
      "ratedNote": "In einer direkten Herausforderung kannst du die Auslosung begrenzen: bis 2N/2B zählt eine einzelne Partie für die Wertung, darüber ist ein Wettkampf über zwei Partien nötig.",
      "tableAll": "General",
      "tableA": "Tabelle A",
      "tableB": "Tabelle B",
      "tableC": "Tabelle C",
      "tableD": "Tabelle D",
      "count": "{{count}} Eröffnungen",
      "colNumber": "Nr.",
      "colOpening": "Eröffnung",
      "colStrength": "Bewertung",
      "colStrengthShort": "Bew.",
      "colTables": "Tabellen",
      "colTablesShort": "Tab.",
      "firstMove": "Erster Zug {{move}}",
      "legendTitle": "So liest man die Bewertung",
      "legendColours": "N = Schwarz (Nero), B = Weiß (Bianco).",
      "legendPari": "PARI — ausgeglichenes Spiel.",
      "legend1": "1N / 1B — diese Farbe steht etwas besser und hat mehr Auswahl.",
      "legend2": "2N / 2B — diese Farbe steht deutlich besser, der Gegner spielt defensiv.",
      "legend3": "3N / 3B — diese Farbe ist übermächtig: der Gegner braucht präzise Manöver für ein Remis.",
      "legend4": "4N / 4B — diese Farbe gilt nach heutigem Wissen als gewinnend.",
      "tablesTitle": "Die Verbandstabellen",
      "italianA": "Nur Wettkämpfe über zwei Partien sowie Paar- und Mannschaftswettbewerbe.",
      "italianB": "Standardtabelle offizieller Wettkämpfe; auch für eine einzelne Partie geeignet.",
      "italianC": "Teilmenge von B für Jugend- und Provinzkategorien sowie Förderturniere.",
      "italianD": "Die als gewonnen geltenden Eröffnungen: nur Wettkämpfe über zwei Partien.",
      "englishA": "Die Tabelle, die normalerweise in Wettkämpfen über zwei Partien und im Mannschaftsspiel verwendet wird.",
      "englishB": "Turniere mit nur einer Partie pro Begegnung.",
      "englishC": "Teilmenge von B für die in den Ausschreibungen vorgesehenen Sonderfälle.",
      "englishD": "Die als gewonnen geltenden Eröffnungen: nur Wettkämpfe über zwei Partien.",
      "tableEvery": "Alle",
      "everyTitle": "Warum aus 302 Eröffnungen 174 werden",
      "everyIntro": "Es gibt {{total}} legale Eröffnungen über drei Halbzüge, sie führen aber nur zu {{positions}} verschiedenen Stellungen: die Generaltabelle wählt {{listed}} davon, eine je Stellung. So ergeht es dem Rest.",
      "status_ballot": "In der Tabelle",
      "statusBallotDesc": "Auslosbar: eine der offiziellen Eröffnungen.",
      "statusTransposition": "Wie Nr. {{id}}",
      "statusTranspositionShort": "Zugumstellung",
      "statusTranspositionDesc": "Dieselbe Endstellung wie eine bereits gelistete Eröffnung, nur über eine andere Zugfolge: dieselbe Partie unter anderem Namen.",
      "status_material": "Verliert einen Stein",
      "statusMaterialDesc": "Nach dem dritten Halbzug steht eine Farbe einen Stein zurück, ohne Rückschlag: das sind die beiden Kombinationen, die das Reglement seit jeher ausschließt.",
      "status_unlisted": "Nicht gelistet",
      "statusUnlistedDesc": "Eine Stellung, die die Tabelle gar nicht abdeckt. Es gibt keinen mechanischen Grund: der Verband hat die studierenswerten Linien ausgewählt.",
      "statusDecidedDesc": "Bleiben in der Tabelle, aber nur für Wettkämpfe über zwei Partien: sie gelten für die bevorzugte Farbe als gewonnen — für die andere also als verloren.",
      "colPosition": "Stellung"
    },
    "capture": {
      "cta": "Die Schlagregeln",
      "ctaDesc": "Die Schlagrangfolge, Schritt für Schritt, mit Beispielen.",
      "title": "Schlagregeln",
      "heroSubtitle": "Wann Schlagzwang gilt, welchen Schlag man ausführen muss und wie gezählt wird, bei {{variant}}.",
      "intro": "Das Schlagen ist der am strengsten geregelte Teil des Spiels. Zu wissen, wie geschlagen wird, genügt nicht: man muss wissen, welchen Schlag man ausführen muss. Alle Regeln stehen hier, in genau der Reihenfolge, in der das Spiel sie anwendet.",
      "source": "Quelle: Technisches Reglement F.I.D., Januar 2025.",
      "mandatoryTitle": "Schlagen ist Pflicht",
      "mandatoryBody": "Gibt es am Zug auch nur einen Schlag, verschwinden alle stillen Züge: sie sind keine schlechten Züge, es gibt sie schlicht nicht. Der Zwang gilt für die ganze Stellung, nicht für einen einzelnen Stein.",
      "mandatoryRejected": "Ein Fehler wird nicht bestraft: ein regelwidriger Schlag wird abgelehnt und die Stellung bleibt, wie sie war.",
      "geometryTitle": "Wie ein Schlag abläuft",
      "geometryShortKing": "Auch die Dame springt nur ein Feld weit: der gegnerische Stein muss diagonal unmittelbar neben ihr stehen.",
      "geometryLanding": "Das Feld hinter dem geschlagenen Stein muss frei sein. Ist es besetzt, von welchem Stein auch immer, oder liegt es außerhalb des Bretts, gibt es diesen Schlag nicht.",
      "menVsKingTitle": "Steine und Damen",
      "menVsKingWall": "Für einen Stein ist die gegnerische Dame eine Mauer: er kann sie weder schlagen noch überspringen. Eine Dame vor einer Gruppe von Steinen macht diese für alle Steine unantastbar.",
      "menVsKingFree": "Es gibt keine Beschränkung nach Rang: jeder Stein darf jeden Stein schlagen.",
      "multiTitle": "Der Mehrfachschlag",
      "multiBody": "Steht der Stein nach einem Sprung erneut vor einem schlagbaren Stein, muss er weiterschlagen. Auf halbem Weg aufzuhören ist keine Wahl: eine unvollständige Folge ist kein gültiger Zug.",
      "multiDirection": "Bei jedem Sprung darf die Richtung wechseln. Ein Stein wechselt jedoch nur zwischen seinen beiden Vorwärtsdiagonalen: er gewinnt während der Folge nie den Rückwärtsschlag.",
      "multiNoTwice": "Derselbe gegnerische Stein darf in einer Folge nicht zweimal übersprungen werden. Dasselbe leere Feld darf dagegen beliebig oft überquert werden.",
      "ladderTitle": "Die Schlagrangfolge",
      "ladderIntro": "Sind mehrere Schläge möglich, hat man keine Wahl. Das Spiel vergleicht sie nach diesen Kriterien, in dieser Reihenfolge: das nächste Kriterium greift nur, wenn das vorige mehrere Schläge gleichauf lässt.",
      "ladderWholePosition": "Verglichen werden alle Schläge aller eigenen Steine. Ein Stein kann also festsitzen, weil ein anderer Stein den besseren Schlag hat.",
      "ladderNoneIntro": "Schlagen ist Pflicht, welchen Schlag man ausführt bleibt jedoch völlig frei. Es gibt keinerlei Rangfolge: ein einfacher Schlag zählt so viel wie ein Mehrfachschlag, und nichts zwingt dazu, mehr zu nehmen.",
      "levelLabel": "Stufe {{n}}",
      "levelMaxPieces": "Man muss den Schlag ausführen, der die meisten Steine schlägt.",
      "whyMaxPieces": "Gezählt werden Steine, nicht ihr Wert: zwei Steine schlagen eine Dame aus dem Feld.",
      "levelMaxValue": "Man muss den Schlag mit dem höchsten Gesamtwert ausführen.",
      "whyMaxValue": "Damen wiegen mehr als Steine, daher gewinnt nicht immer die längste Folge.",
      "levelWithKing": "Bei gleicher Steinzahl muss mit der Dame geschlagen werden, nicht mit dem Stein.",
      "whyWithKing": "Das Kriterium betrifft den schlagenden Stein, nicht den geschlagenen. Schlagen eine Dame und ein Stein gleich viele Steine, muss die Dame ziehen, auch wenn der Stein wertvollere Steine nähme.",
      "levelMaxKings": "Bleibt es gleich, muss der Schlag ausgeführt werden, der die meisten Damen schlägt.",
      "whyMaxKings": "Hier zählt der Wert dessen, was man dem Gegner nimmt. Da nur Damen Damen schlagen können, trennt dieses Kriterium ausschließlich Schläge einer Dame.",
      "levelFirstKing": "Bleibt es gleich, muss die Folge gewählt werden, die am frühesten eine Dame schlägt.",
      "whyFirstKing": "Betrachtet wird die Reihenfolge der Sprünge: von zwei Wegen, die dieselben Steine nehmen, gewinnt der, der die Dame beim früheren Sprung trifft.",
      "levelFree": "Bleiben die Schläge gleichwertig, ist die Wahl frei.",
      "whyFree": "Jenseits dieses Punktes bindet keine Regel mehr: zwei in allen Kriterien identische Schläge dürfen beliebig gespielt werden.",
      "removalTitle": "Wann die Steine vom Brett kommen",
      "removalEnd": "Geschlagene Steine bleiben bis zum Ende des Zuges auf dem Brett und werden erst gemeinsam entfernt, wenn die Folge abgeschlossen ist. Deshalb sieht man sie während eines Mehrfachschlags noch an ihrem Platz.",
      "removalImmediate": "Das frei gewordene Feld steht sofort wieder zur Verfügung. Denselben Stein zweimal zu überspringen bleibt verboten.",
      "promotionTitle": "Die Umwandlung beendet den Schlag",
      "promotionBody": "Erreicht ein Stein während einer Folge die letzte Reihe, endet der Zug dort: der Stein wird zur Dame und der Gegner ist am Zug, auch wenn von diesem Feld aus weitere Sprünge möglich wären. Die neue Dame zieht erst im folgenden Zug.",
      "promotionNoExemption": "Die Umwandlung befreit nicht von der Rangfolge: die abgebrochene Folge wird mit den Steinen verglichen, die sie tatsächlich geschlagen hat. Nimmt ein anderer Schlag mehr, ist der umwandelnde regelwidrig.",
      "promotionStillAMan": "Für die Rangfolge zählt ein sich umwandelnder Stein weiterhin als Stein: er erhält nicht den Vorrang einer Dame.",
      "noHuffingTitle": "Kein Blasen",
      "noHuffingBody": "Die \"Blas\"-Regel gilt nicht: wer einen Pflichtschlag versäumt, verliert den Stein nicht, er kann diesen Zug nur nicht spielen.",
      "exGeometry": "Weiß überspringt den benachbarten Stein und landet unmittelbar dahinter.",
      "exMenVsKingWall": "Der Stein steht neben einer gegnerischen Dame und kann sie nicht schlagen: es bleibt nur ein stiller Zug.",
      "exMenVsKingFree": "Hier schlägt der Stein die Dame wie jeden anderen Stein.",
      "exMulti": "Nur ein gültiger Zug: die Folge muss zu Ende geführt werden.",
      "exPromotion": "Weiß erreicht die letzte Reihe, also endet der Zug dort — auch wenn noch ein Stein zu schlagen wäre.",
      "exMaxPieces": "Zwei Schläge möglich: einer nimmt einen Stein, der andere zwei. Nur der längere ist gültig.",
      "exMaxValue": "Unter den möglichen Schlägen entscheidet der Gesamtwert der geschlagenen Steine.",
      "exWithKing": "Dame und Stein schlagen je einen Stein: ziehen muss die Dame.",
      "exMaxKings": "Zwei Damen können schlagen: zu nehmen ist die gegnerische Dame, nicht der Stein.",
      "exFirstKing": "Zwei Wege über zwei Steine mit je einer Dame: Pflicht ist der, der die Dame zuerst nimmt.",
      "exFree": "Dieselbe Runde, in beide Richtungen, nimmt dieselben vier Steine: man darf wählen.",
      "exFreeNoLadder": "Ein Schlag nimmt einen Stein, der andere zwei: hier sind beide gültig.",
      "forced": "Pflichtzug",
      "choices": "Gültige Züge",
      "diagramAlt": "Beispielstellung"
    },
    "gameRulesHead": "Spielregeln"
  },
  "faq": {
    "title": "FAQ & Kontakt",
    "intro": "Häufig gestellte Fragen und ein direkter Kanal für Probleme, Anfragen und Rückmeldungen.",
    "questionsTitle": "Häufig gestellte Fragen",
    "entries": [
      {
        "id": "install-android",
        "q": "Wie installiere ich die App auf Android?",
        "a": "Die App wird direkt aus dem Browser installiert — der Play Store ist nicht nötig.\n1. Öffne die Seite in Chrome (oder Edge, Samsung Internet).\n2. Tippe oben rechts auf das Menü ⋮.\n3. Wähle \"App installieren\" (oder \"Zum Startbildschirm hinzufügen\") und bestätige.\nManchmal zeigt der Browser von selbst ein Installationsbanner an — das kannst du ebenfalls nutzen. Das Symbol erscheint dann bei deinen übrigen Apps und das Spiel öffnet sich im Vollbild, ohne Browserleiste."
      },
      {
        "id": "install-ios",
        "q": "Wie installiere ich die App auf iPhone oder iPad?",
        "a": "Auf iPhone und iPad läuft es anders und funktioniert nur mit Safari.\n1. Öffne die Seite in Safari (in anderen Browsern fehlt die Option oft).\n2. Tippe auf \"Teilen\" (das Quadrat mit dem Pfeil nach oben): unten auf dem iPhone, oben auf dem iPad.\n3. Scrolle in der Liste nach unten und wähle \"Zum Home-Bildschirm\".\n4. Tippe oben rechts auf \"Hinzufügen\".\niOS zeigt nie einen automatischen Installationshinweis: ohne diese Schritte wird kein Symbol angelegt."
      },
      {
        "id": "install-desktop",
        "q": "Kann ich die App auf dem Computer installieren?",
        "a": "Ja, mit Chrome oder Edge.\n1. Öffne die Seite.\n2. Klicke rechts in der Adressleiste auf das Installationssymbol oder wähle im Browsermenü \"Installieren…\".\n3. Bestätige: Die App öffnet sich in einem eigenen Fenster, ohne Browserleiste.\nFirefox und Safari am Computer unterstützen die Installation nicht — du kannst trotzdem ganz normal im Browser spielen und die Seite als Lesezeichen speichern."
      },
      {
        "id": "login",
        "q": "Ich kann mich nicht in mein Konto einloggen — was kann ich tun?",
        "a": "Stelle sicher, dass E-Mail-Adresse und Passwort korrekt sind. Wenn du dein Passwort vergessen hast, nutze den Link \"Passwort vergessen\" auf der Anmeldeseite. Bleibt das Problem bestehen, fülle bitte das untenstehende Formular aus und wähle die Kategorie \"Anmeldeproblem\"."
      },
      {
        "id": "verify-email",
        "q": "Ich habe die Verifizierungs-E-Mail nicht erhalten — wie bekomme ich sie erneut?",
        "a": "Öffne den Anmeldedialog, versuche dich mit deinen Zugangsdaten anzumelden und klicke auf \"Verifizierungs-E-Mail erneut senden\". Schau auch im Spam-Ordner nach."
      },
      {
        "id": "variant-request",
        "q": "Kann ich eine neue Damevariante vorschlagen?",
        "a": "Ja! Fülle das Kontaktformular unten aus, wähle \"Neue Variante anfragen\" und beschreibe die Regeln der Variante, die du gerne unterstützt sehen würdest."
      },
      {
        "id": "rules-wrong",
        "q": "Die Regeln einer Variante scheinen falsch zu sein — wie melde ich das?",
        "a": "Fülle das Kontaktformular unten aus und wähle \"Regelkorrektur\". Gib an, welche Variante betroffen ist, und beschreibe die Regel, die korrigiert werden soll, idealerweise mit einem Verweis auf die offizielle Quelle (FMJD, FID, WCDF usw.)."
      },
      {
        "id": "delete-account",
        "q": "Wie lösche ich mein Konto?",
        "a": "Öffne die Profileinstellungen: Dort findest du Optionen, deine Daten (DSGVO) zu exportieren und dein Konto endgültig zu löschen. Die Löschung ist unwiderruflich."
      }
    ],
    "contactTitle": "Kontaktiere uns",
    "contactIntro": "Keine Antwort gefunden? Schreib uns und wir antworten per E-Mail.",
    "category": {
      "login": "Anmeldeproblem",
      "variant_request": "Neue Variante anfragen",
      "rules": "Regelkorrektur",
      "other": "Sonstiges"
    },
    "fields": {
      "name": "Name (optional)",
      "email": "E-Mail",
      "category": "Kategorie",
      "subject": "Betreff",
      "message": "Nachricht"
    },
    "submit": "Anfrage senden",
    "success": "Danke! Deine Anfrage wurde gesendet. Wir antworten so bald wie möglich per E-Mail.",
    "errors": {
      "invalidEmail": "Bitte gib eine gültige E-Mail-Adresse ein.",
      "subjectTooShort": "Der Betreff muss mindestens 3 Zeichen enthalten.",
      "messageTooShort": "Die Nachricht muss mindestens 10 Zeichen enthalten.",
      "rateLimited": "Du hast in kurzer Zeit zu viele Anfragen gesendet. Bitte versuche es in einer Stunde erneut.",
      "submitFailed": "Senden fehlgeschlagen. Prüfe deine Verbindung und versuche es erneut."
    }
  },
  "home": {
    "heroTitle": "Dame Online",
    "heroTagline": "Die Plattform für internationales, italienisches und englisches Dame. Spiele, nimm an Turnieren teil und erklimme die Rangliste.",
    "welcome": "Willkommen",
    "newGame": "Neues Spiel",
    "chooseMode": "Wähle deinen Spielmodus",
    "startNow": "Spielen",
    "vsAI": "Gegen KI spielen",
    "vsAIDesc": "Übe gegen den Computer",
    "vsOnline": "Online Spielen",
    "vsOnlineDesc": "Fordere echte Spieler heraus",
    "vsFriends": "Mit Freunden spielen",
    "vsFriendsDesc": "Erstelle oder trete einem privaten Spiel bei",
    "createTable": "Tisch erstellen",
    "createTableDesc": "Lade einen Freund ein",
    "joinTable": "Tisch beitreten",
    "joinTableDesc": "Gib einen Raumcode ein",
    "enterRoomCode": "Gib den Raumcode ein, den dein Freund geteilt hat",
    "variant": "Variante",
    "difficulty": "Schwierigkeit",
    "timeControl": "Zeitkontrolle",
    "startGame": "Spiel starten",
    "playersOnline": "Spieler online",
    "gamesInProgress": "Spiele laufend",
    "landing": {
      "heroTitle": "Dame Spielen",
      "heroTitleAccent": "Online",
      "heroTagline": "Damevarianten aus aller Welt. Turniere, gewertete Spiele, KI-Gegner — jetzt spielen.",
      "playFree": "Jetzt Spielen",
      "signUp": "Registrieren",
      "playAsGuest": "Als Gast Spielen",
      "featuresLabel": "Warum Dame?",
      "featuresTitle": "Alles was du zum Spielen brauchst",
      "featuresSubtitle": "Eine komplette Plattform für kompetitive und Gelegenheitsspieler.",
      "featureTournaments": "Turniere",
      "featureTournamentsDesc": "Swiss- und Arena-Formate mit automatischer Paarung, Glicko-2 Wertung und Echtzeit-Ranglisten.",
      "featureRating": "Bewertungssystem",
      "featureRatingDesc": "Separate Glicko-2 Bewertungen für Varianten und Zeitkontrollen. Verfolge deinen Fortschritt.",
      "featureAI": "KI-Gegner",
      "featureAIDesc": "6 Schwierigkeitsstufen vom Anfänger bis zum Experten. Übe jederzeit, ohne Wartezeit.",
      "featureVariants": "Weltvarianten",
      "featureVariantsDesc": "Von Internationalem und Italienischem bis Türkischem, Friesischem und mehr — Damevarianten aus aller Welt.",
      "featureOnline": "Online spielen",
      "featureOnlineDesc": "Finde in Sekunden per Matchmaking einen Gegner und spiele gewertete oder freundschaftliche Partien.",
      "featurePuzzles": "Tägliche Rätsel",
      "featurePuzzlesDesc": "Jeden Tag ein neues Rätsel in mehreren Varianten. Schärfe deine Taktik und steigere deine Wertung.",
      "specBoard": "{{size}}-Brett",
      "specPieces": "{{count}} Steine pro Seite",
      "specFlyingKings": "Fliegende Damen",
      "specShortKings": "Kurze Damen",
      "howLabel": "Wie?",
      "howTitle": "In Sekunden losspielen",
      "step1Title": "Erstelle ein Konto",
      "step1Desc": "Registriere dich in Sekunden. Oder spiele sofort als Gast.",
      "step2Title": "Wähle dein Spiel",
      "step2Desc": "Wähle Variante, Zeitkontrolle und spiele gegen Menschen oder KI.",
      "step3Title": "Steige in der Rangliste",
      "step3Desc": "Gewinne Spiele, sammle Wertungspunkte und nimm an täglichen Turnieren teil.",
      "variantsLabel": "Spielvarianten",
      "variantsTitle": "Jede Variante des Damespiels, eine Plattform",
      "variantsMoreTitle": "Und viele weitere Varianten",
      "variantsAllCta": "Die Regeln jeder Variante ansehen",
      "intlBadge": "FMJD Offiziell",
      "intlDesc": "Der Standard für kompetitives Damespiel weltweit. Fliegende Damen, Schlagpflicht und Regel der längsten Schlagfolge.",
      "italianBadge": "Traditionell",
      "italianDesc": "Die beliebte italienische Tradition. Steine können keine Damen schlagen und die Meiste-Steine-Schlagen-Regel erzeugt tiefes taktisches Spiel.",
      "englishBadge": "WCDF Offiziell",
      "englishDesc": "Klassisches 8×8-Dame weltweit gespielt. Schlagpflicht, nicht-fliegende Damen, Steine können Damen schlagen und keine Rückwärtsbewegung für Steine.",
      "brazilianBadge": "Beliebt",
      "brazilianDesc": "Brasiliens beliebteste Dame-Variante. 8×8-Brett mit fliegenden Damen, Pflicht zur längsten Schlagfolge und Steine schlagen rückwärts.",
      "ctaTitle": "Bereit zu spielen?",
      "ctaSubtitle": "Werde Teil der Community. Starte dein erstes Spiel.",
      "ctaButton": "Jetzt Losspielen",
      "heroCta": "Jetzt spielen",
      "puzzleTitle": "Probier ein Rätsel",
      "puzzleSubtitle": "Löse diese Stellung sofort – ganz ohne Anmeldung. Erstelle danach ein kostenloses Konto, um das Tagesrätsel zu spielen und dein Rating zu steigern."
    },
    "dashboard": {
      "welcomeBack": "Willkommen zurück",
      "recentGames": "Letzte Spiele",
      "viewAll": "Alle Anzeigen",
      "liveUpcoming": "Live & Kommend",
      "allTournaments": "Alle Turniere",
      "thisWeek": "diese Woche",
      "live": "LIVE",
      "join": "Beitreten",
      "noRecentGames": "Noch keine Spiele. Spiele dein erstes!",
      "noTournaments": "Keine anstehenden Turniere.",
      "timeAgo": {
        "now": "gerade eben",
        "minutes": "vor {{count}} Min",
        "hours": "vor {{count}}h",
        "yesterday": "Gestern",
        "days": "vor {{count}}T",
        "weeks": "vor {{count}}W",
        "months": "vor {{count}}M"
      },
      "dailyPuzzle": {
        "title": "Tagesrätsel",
        "whiteToMove": "Weiß am Zug",
        "blackToMove": "Schwarz am Zug"
      }
    }
  },
  "game": {
    "header": {
      "rated": "Gewertet",
      "casual": "Freundschaftlich",
      "variantRules": "Regeln der Variante"
    },
    "variants": {
      "international": "Internationales Dame 10×10",
      "internationalShort": "International 10×10",
      "internationalMedium": "International 10×10",
      "italian": "Italienisches Dame 8×8",
      "italianShort": "Italienisch 8×8",
      "english": "Englisches Dame 8×8",
      "englishShort": "Englisch 8×8",
      "englishBadge": "WCDF Offiziell",
      "englishDesc": "Klassisches 8×8-Dame weltweit gespielt. Schlagpflicht, nicht-fliegende Damen, Steine können Damen schlagen und keine Rückwärtsbewegung für Steine.",
      "brazilian": "Brasilianisches Dame 8×8",
      "brazilianShort": "Brasilianisch 8×8",
      "frisian": "Friesisches Dame 10×10",
      "frisianShort": "Friesisch 10×10",
      "frysk": "Frysk! 10×10",
      "fryskShort": "Frysk 10×10",
      "turkish": "Türkisches Dame 8×8",
      "turkishShort": "Türkisch 8×8",
      "armenian": "Armenisches Tama 8×8",
      "armenianShort": "Armenisch 8×8",
      "russian": "Russisches Dame 8×8",
      "russianShort": "Russisch 8×8",
      "spanish": "Spanisches Dame 8×8",
      "spanishShort": "Spanisch 8×8",
      "triestine": "Triestiner Dame 10×10",
      "triestineShort": "Triestiner 10×10",
      "canadian": "Kanadisches Dame 12×12",
      "canadianShort": "Kanadisch 12×12",
      "nigerian": "Nigerianisches Dame 10×10",
      "nigerianShort": "Nigerianisch 10×10",
      "ghanaian": "Ghanaisches Dame 10×10",
      "ghanaianShort": "Ghanaisch 10×10",
      "pool": "Pool Checkers 8×8",
      "poolShort": "Pool 8×8",
      "czech": "Tschechisches Dame 8×8",
      "czechShort": "Tschechisch 8×8",
      "thai": "Thai Makhos 8×8",
      "thaiShort": "Thai 8×8",
      "portuguese": "Portugiesisches Dame 8×8",
      "portugueseShort": "Portugiesisch 8×8",
      "filipino": "Philippinisches Dame 8×8",
      "filipinoShort": "Philippinisch 8×8",
      "malaysian": "Malaysisches Dame 12×12",
      "malaysianShort": "Malaysisch 12×12",
      "german": "Damenspiel 8×8",
      "germanShort": "Deutsch 8×8",
      "jamaican": "Jamaikanisches Dame 8×8",
      "jamaicanShort": "Jamaikanisch 8×8",
      "sinhalese": "Singhalesisches Dame 8×8",
      "sinhaleseShort": "Singhalesisch 8×8",
      "south_african": "Südafrikanisches Dame 14×14",
      "south_africanShort": "Südafrikanisch 14×14",
      "dameo": "Dameo 8×8",
      "dameoShort": "Dameo 8×8",
      "croda": "Croda 8×8",
      "crodaShort": "Croda 8×8"
    },
    "opponent": {
      "computer": "AI"
    },
    "modes": {
      "twoPlayers": "2 Spieler",
      "aiVeryEasy": "Sehr Leicht",
      "aiEasy": "Leicht",
      "aiMedium": "Mittel",
      "aiHard": "Schwer",
      "aiExpert": "Sehr Schwer",
      "aiMaster": "Experte",
      "playOnline": "Online Spielen"
    },
    "timeControls": {
      "noTimeLimit": "Keine Zeitbegrenzung",
      "blitz30": "Blitz 3+0",
      "blitz32": "Blitz 3+2",
      "blitz50": "Blitz 5+0",
      "blitz53": "Blitz 5+3",
      "rapid105": "Rapid 10+5",
      "rapid1510": "Rapid 15+10"
    },
    "turn": {
      "yourTurn": "Du bist dran",
      "opponentTurn": "Gegner ist dran",
      "toMove": "Am Zug",
      "aiThinking": "KI denkt nach...",
      "aiTurn": "KI-Zug",
      "aiDeclinedDraw": "Der Computer hat das Remis abgelehnt",
      "whiteToMove": "Weiß am Zug",
      "blackToMove": "Schwarz am Zug"
    },
    "result": {
      "youWin": "Du Gewinnst!",
      "youLose": "Du Verlierst!",
      "draw": "Unentschieden!",
      "whiteWins": "Weiß Gewinnt!",
      "blackWins": "Schwarz Gewinnt!",
      "gameOver": "Spiel Vorbei",
      "gameAbandoned": "Spiel Abgebrochen",
      "noWinner": "Partie beendet",
      "won": "Gewonnen",
      "lost": "Verloren"
    },
    "drawCountdown": {
      "aria_one": "Automatisches Remis in {{count}} Zug, wenn nur Damen ziehen",
      "aria_other": "Automatisches Remis in {{count}} Zügen, wenn nur Damen ziehen"
    },
    "frisianCountdown": {
      "aria_one": "Automatisches Remis in {{count}} Zug: zwei Damen gegen eine",
      "aria_other": "Automatisches Remis in {{count}} Zügen: zwei Damen gegen eine"
    },
    "endReason": {
      "checkmate": "keine Züge",
      "noLegalMoves": "hat keine legalen Züge mehr.",
      "whiteNoMoves": "Weiß hat keine legalen Züge mehr.",
      "blackNoMoves": "Schwarz hat keine legalen Züge mehr.",
      "drawEnded": "Das Spiel endete unentschieden.",
      "gameAbandoned": "Das Spiel wurde abgebrochen.",
      "noWinner": "Die Partie endete ohne Sieger.",
      "gameEnded": "Das Spiel ist beendet.",
      "resignation": "Aufgabe",
      "disconnection": "Verbindung getrennt",
      "fiftyMoves": "50-Züge-Regel",
      "timeout": "Zeit abgelaufen",
      "agreement": "Remis durch Einigung",
      "walkover": "kampfloser Sieg",
      "firstKing": "Erste Dame",
      "sideResigned": "{{side}} hat aufgegeben.",
      "sideTimeout": "{{side}} hat die Zeit überschritten.",
      "sideNoPieces": "{{side}} hat keine Steine mehr.",
      "moveLimit": "Zu viele Züge ohne Schlag.",
      "repetition": "Dieselbe Stellung dreimal wiederholt.",
      "endgameDraw": "Theoretisch remises Endspiel.",
      "sideZugzwang": "{{side}} ist im Zugzwang: jeder Zug verliert.",
      "loneKing": "Eine einzelne Dame schlägt einen einzelnen Stein.",
      "sideSinglePiece": "{{side}} blieb mit einem einzigen Stein übrig.",
      "drawAgreed": "Remis durch Übereinkunft.",
      "sideNoFirstMove": "{{side}} hat nicht rechtzeitig gezogen.",
      "noFirstMove": "Erster Zug nicht rechtzeitig gespielt."
    },
    "actions": {
      "newGame": "Neues Spiel",
      "resign": "Aufgeben",
      "endGame": "Beenden",
      "leaveGame": "Spiel Verlassen",
      "backToLobby": "Zurück zur Lobby",
      "offerDraw": "Remis",
      "drawOffered": "Dein Gegner bietet ein Remis an",
      "drawSent": "Remis angeboten…",
      "acceptDraw": "Annehmen",
      "declineDraw": "Ablehnen",
      "drawDeclined": "Dein Gegner hat das Remis abgelehnt",
      "drawMoveFirst": "Erst ziehen",
      "drawMustMoveFirst": "Mach einen Zug, bevor du erneut ein Remis anbietest.",
      "drawNoneLeft": "Keine Angebote",
      "drawLimitReached": "Du hast alle Remisangebote in dieser Partie verbraucht.",
      "drawTooFast": "Zu viele Remisangebote. Warte einen Moment.",
      "requestTakeback": "Zug zurücknehmen",
      "takebackRequested": "Rücknahme angefragt…",
      "opponentRequestsTakeback_one": "Gegner möchte {{count}} Zug zurücknehmen",
      "opponentRequestsTakeback_other": "Gegner möchte {{count}} Züge zurücknehmen",
      "acceptTakeback": "Annehmen",
      "declineTakeback": "Ablehnen",
      "takebackDeclined": "Deine Zugrücknahme wurde abgelehnt",
      "takebackAccepted": "Deine Zugrücknahme wurde angenommen",
      "takebackDisabledRated": "Zugrücknahme ist in gewerteten Partien deaktiviert",
      "focus": "Fokus",
      "focusExit": "Beenden",
      "peek": "Spicken",
      "boardSize": "Brettgröße",
      "boardBigger": "Größeres Brett",
      "boardSmaller": "Kleineres Brett",
      "flipBoard": "Drehen"
    },
    "confirmLeave": "Möchtest du das Spiel wirklich verlassen?",
    "confirmLeaveTitle": "Spiel verlassen?",
    "confirmLeaveCancel": "Abbrechen",
    "confirmLeaveButton": "Verlassen",
    "confirmResignTitle": "Aufgeben?",
    "confirmResign": "Möchtest du wirklich aufgeben? Du verlierst die Partie.",
    "confirmEndGameTitle": "Partie beenden?",
    "confirmEndGame": "Die Partie endet ohne Sieger.",
    "clock": {
      "white": "Weiß",
      "black": "Schwarz"
    },
    "aborted": {
      "opponentLeft": "Dein Gegner hat die Partie vor dem ersten Zug verlassen — wir suchen einen neuen Gegner…",
      "opponentDidNotMove": "Dein Gegner hat nicht rechtzeitig gezogen — Partie annulliert."
    },
    "disconnection": {
      "opponentDisconnected": "Gegner Getrennt",
      "waitingToReconnect": "Warten auf Wiederverbindung des Gegners...",
      "opponentLeft": "Gegner hat das Spiel verlassen",
      "disconnected": "Getrennt",
      "notPresent": "Nicht da",
      "avvisoMaiArrivato": "Gegner noch nicht da: kommt er nicht, gewinnst du, wenn seine Uhr abläuft.",
      "avvisoDecideOrologio": "Gegner getrennt: kommt er nicht zurück, gewinnst du, wenn seine Uhr abläuft.",
      "avvisoGrazia": "Gegner getrennt: kommt er nicht binnen {{secondi}} s zurück, gewinnst du.",
      "avvisoMaiArrivatoTuoTurno": "Gegner noch nicht da: zieh du; kommt er nicht, gewinnst du, wenn seine Uhr abläuft.",
      "avvisoDecideOrologioTuoTurno": "Gegner getrennt: zieh du; kommt er nicht zurück, gewinnst du, wenn seine Uhr abläuft."
    },
    "sidebar": {
      "moves": "Züge",
      "openingNumbered": "Eröffnung Nr. {{n}}",
      "openingDrawn": "Ausgeloste Eröffnung",
      "chat": "Chat",
      "spectators": "Zuschauer",
      "noMoves": "Noch keine Züge",
      "viewMove": "Stellung nach Zug {{n}} ansehen",
      "goToStart": "Zum Anfang",
      "prevMove": "Vorheriger Zug",
      "nextMove": "Nächster Zug",
      "goLive": "Zur aktuellen Stellung",
      "play": "Abspielen",
      "pause": "Pause",
      "position": "Position in der Variante",
      "showMoves": "Züge anzeigen",
      "hideMoves": "Züge ausblenden"
    },
    "blind": {
      "lastMove": "Letzter Zug",
      "promoted": "Dame",
      "noPeeks": "Partie ohne ein einziges Spicken gespielt.",
      "peeks_one": "Du hast {{count}} Mal gespickt.",
      "peeks_other": "Du hast {{count}} Mal gespickt."
    },
    "confirmDrawTitle": "Remis?",
    "confirmDraw": "Die Partie als Remis beenden? Beide Spieler müssen einverstanden sein.",
    "match": {
      "playReturn": "Rückpartie spielen"
    },
    "primaMossa": {
      "secondi_one": "{{count}}s",
      "secondi_other": "{{count}}s",
      "ariaVoid_one": "Erster Zug innerhalb {{count}} Sekunde, sonst wird die Partie annulliert",
      "ariaVoid_other": "Erster Zug innerhalb {{count}} Sekunden, sonst wird die Partie annulliert",
      "ariaForfeit_one": "Erster Zug innerhalb {{count}} Sekunde, sonst verlierst du kampflos",
      "ariaForfeit_other": "Erster Zug innerhalb {{count}} Sekunden, sonst verlierst du kampflos"
    },
    "saluto": {
      "invia": "Wünsche deinem Gegner ein gutes Spiel",
      "mittente": "{{username}}:",
      "ancheATe": "Dir auch",
      "inviato": "Begrüßung gesendet"
    }
  },
  "online": {
    "title": "Online Spielen",
    "playOnline": "Online Spielen",
    "connecting": "Verbindung zum Server...",
    "connectionFailed": "Verbindung Fehlgeschlagen",
    "couldNotConnect": "Verbindung zum Spielserver fehlgeschlagen.",
    "error": "Fehler",
    "room": {
      "title": "Raum",
      "code": "Raumcode",
      "shareCode": "Teile diesen Raumcode:",
      "playAs": "Du spielst als",
      "waitingForOpponent": "Warte auf Gegner"
    },
    "lobby": {
      "findMatch": "Spiel Finden",
      "matchmakingByRating": "Automatische Spielersuche nach Rating",
      "signInToMatch": "Melde dich an, um das automatische Matchmaking zu nutzen",
      "createGame": "Spiel Erstellen",
      "selectVariantAndTime": "Variante und Zeitkontrolle wählen",
      "createRoom": "Raum Erstellen",
      "joinGame": "Spiel Beitreten",
      "enterRoomCode": "Raumcode eingeben zum Beitreten",
      "join": "Beitreten",
      "playWithFriends": "oder mit Freunden spielen"
    },
    "matchmaking": {
      "findingOpponent": "Gegner wird gesucht...",
      "matchingSimilarSkill": "Suche nach Spieler mit ähnlichem Niveau...",
      "creatingRoom": "Raum wird erstellt...",
      "joiningRoom": "Trete Raum bei...",
      "estimatedWait": "Geschätzte Wartezeit: ~{{seconds}}s",
      "timeout": "Kein Gegner gefunden. Versuche es erneut."
    },
    "errors": {
      "authRequired": "Du musst angemeldet sein, um online zu spielen.",
      "alreadyInQueue": "Du suchst bereits nach einem Spiel.",
      "alreadyInGame": "Du bist bereits in einem Spiel.",
      "generico": "Etwas ist schiefgelaufen. Versuch es erneut.",
      "nonConnesso": "Du bist nicht mit dem Server verbunden.",
      "partitaSparita": "Diese Partie gibt es nicht mehr.",
      "drawOfferFailed": "Remis konnte nicht angeboten werden.",
      "serverRestart": "Der Server startet neu: die Partie geht in Kürze weiter. Lade die Seite neu, falls sie nicht zurückkommt.",
      "sfidaTroppeRichieste": "Du hast zu viele Herausforderungen hintereinander gesendet. Warte einen Moment.",
      "avversarioOffline": "Dieser Spieler ist nicht mehr online.",
      "avversarioInPartita": "Dieser Spieler ist bereits in einer Partie. Versuch es erneut, wenn sie vorbei ist.",
      "seiInGara": "Du bist in einem laufenden Turnier oder einer Arena: beende das zuerst.",
      "avversarioInGara": "Dieser Spieler spielt gerade ein Turnier oder eine Arena.",
      "troppePosizioni": "Zu viele eigene Stellungen hintereinander. Warte einen Moment.",
      "impostazioniNonValide": "Diese Einstellungen sind ungültig. Prüfe sie und versuch es erneut.",
      "soloIscritti": "Dieser Spieler kann nur freundschaftliche Partien spielen.",
      "sfidaGiaInVolo": "Du hast schon eine Herausforderung offen. Brich sie zuerst ab.",
      "sfidaGiaMandata": "Du hast diesen Spieler schon herausgefordert: warte auf die Antwort."
    },
    "challenge": {
      "challenge": "Herausfordern",
      "sendChallenge": "Direkte Herausforderung",
      "incomingChallenge": "Eingehende Herausforderung",
      "tabBadge": "Herausforderung!",
      "send": "Senden",
      "accept": "Annehmen",
      "decline": "Ablehnen",
      "cancel": "Abbrechen",
      "loginRequired": "Melde dich an, um Online-Spieler zu sehen und Herausforderungen zu senden",
      "waitingForResponse": "Warten auf {{username}}...",
      "declined": "Herausforderung abgelehnt",
      "expired": "Herausforderung abgelaufen",
      "cancelled": "Herausforderung abgebrochen",
      "color": "Farbe",
      "gameType": "Spieltyp",
      "colorRandom": "Zufällig",
      "rated": "Gewertet (ohne Gäste)",
      "casual": "Freundschaftlich",
      "gameTypeAny": "Gewertet/Freundschaftlich",
      "registeredOnly": "Nur Registrierte",
      "registeredOnlyNote": "Nur registrierte Spieler können diese Partie spielen.",
      "opponentGuestNoRated": "Dieser Gegner ist ein Gast: Die Partie kann nicht gewertet werden.",
      "mode": "Modus",
      "modeNormal": "Standard",
      "modeBreakthrough": "Breakthrough",
      "modeAntidraughts": "Antidame",
      "modeBlind": "Blind",
      "modeInfoLabel": "Über die Spielmodi",
      "modeBreakthroughInfo": "Wer zuerst einen Stein zur Dame umwandelt, gewinnt sofort.",
      "modeAntidraughtsInfo": "Umgekehrtes Ziel: Wer keine Steine oder keinen legalen Zug mehr hat, gewinnt.",
      "modeBlindInfo": "Die Steine sind unsichtbar: Du spielst aus dem Gedächtnis, wie mit verbundenen Augen. Die Regeln bleiben die normalen.",
      "opening": "Eröffnung",
      "legs": "Partien",
      "legsOne": "Nur Hinspiel",
      "legsTwo": "Hin- und Rückspiel",
      "openingDrawnSingleLegCasual": "Mit dieser Eröffnung gleicht eine einzelne Partie den Auslosungsvorteil nicht aus: die Partie ist immer freundschaftlich.",
      "time": "Zeit",
      "increment": "Inkrement",
      "noClockCasual": "Partien ohne Zeitlimit sind immer freundschaftlich.",
      "link": {
        "inviteFriend": "Freund einladen",
        "title": "Freund herausfordern",
        "intro": "Schick diesen Link an wen du willst: Wer ihn zuerst öffnet, spielt gegen dich – auch ohne Konto.",
        "share": "Teilen",
        "copy": "Link kopieren",
        "copied": "Kopiert!",
        "copyFailed": "Link konnte nicht kopiert werden. Markiere ihn und kopiere ihn von Hand.",
        "expiresIn": "Der Link ist noch {{time}} gültig.",
        "startingSoon": "Die Partie beginnt gleich ...",
        "friendAccepted": "{{name}} hat deine Herausforderung angenommen!",
        "cancelLink": "Herausforderung abbrechen",
        "shareTitle": "Dame-Herausforderung",
        "shareText": "Spiel eine Partie Dame gegen mich!",
        "shareTextWith": "Spiel eine Partie Dame gegen mich – {{summary}}",
        "challengesYou": "{{name}} fordert dich zu einer Partie Dame heraus",
        "playNow": "Jetzt spielen",
        "haveAccount": "Ich habe schon ein Konto",
        "guestCasualNote": "Als Gast spielst du eine freundschaftliche Partie (ohne Wertung).",
        "waitingChallengerTitle": "Herausforderung angenommen",
        "waitingChallenger": "Warten, bis {{name}} wieder online ist. Die Partie startet von selbst.",
        "unavailableTitle": "Herausforderung nicht verfügbar",
        "cancelledByChallenger": "Wer dich herausgefordert hat, hat die Partie abgebrochen.",
        "expiredOrGone": "Dieser Link ist abgelaufen oder nicht mehr gültig. Bitte deinen Freund um einen neuen.",
        "backHome": "Zurück zur Startseite"
      },
      "opening_free": "Freier Zug",
      "opening_random1": "1 beliebiger Zufallszug",
      "opening_random2": "2 beliebige Zufallszüge",
      "opening_random3": "3 beliebige Zufallszüge",
      "opening_ballot1": "Tabelle C - 1N/1B",
      "opening_ballot2": "Tabelle B - 2N/2B",
      "opening_ballot3": "Tabelle {{tables}} - 3N/3B",
      "opening_ballot4": "Allgemeine Tabelle",
      "opening_single": "Feste Eröffnung",
      "openingInfoLabel": "Über die Eröffnungen",
      "openingInfo": "Die „Tabelle“-Einträge losen aus den offiziellen F.I.D.-Tabellen: die Zahl in Klammern sagt, aus wie vielen Eröffnungen gelost wird, und die Grenze (1N/1B … 4N/4B) legt fest, wie einseitig es werden darf. Bis Tabelle B zählt eine einzelne Partie für die Wertung; darüber ist ein Wettkampf über zwei Partien nötig. Die „Zufallszüge“-Einträge losen dagegen aus allen legalen Zügen, ganz ohne Grenze: ab 2 Zügen brauchen sie zwei Partien.",
      "openingInfoRandom": "Die ersten Halbzüge werden aus allen legalen Zügen ausgelost: die Zahl in Klammern sagt, wie viele verschiedene Kombinationen herauskommen können. Diese Variante hat keine offiziellen Eröffnungstabellen. Ab 2 Zügen kann die Auslosung eine Farbe bevorzugen, deshalb zählt die Partie nur als Wettkampf über zwei Partien für die Wertung.",
      "openingTablesLink": "Eröffnungstabellen ansehen",
      "guestCannotChallenge": "Direkte Herausforderungen sind registrierten Spielern vorbehalten. Melde dich an oder erstelle ein kostenloses Konto.",
      "guestCasualInvite": "Melde dich an oder erstelle ein kostenloses Konto, um gewertete Partien zu spielen.",
      "changeOpponent": "Ändern",
      "challengePlayer": "{{username}} herausfordern",
      "tableOpen": {
        "title": "{{username}} hat schon einen Tisch offen",
        "other": "Andere Herausforderung senden"
      }
    },
    "status": {
      "playing": "Spielt",
      "playingWith": "Spielt gegen {{username}}",
      "waiting": "Wartet",
      "away": "Abwesend",
      "busy": "Beschäftigt"
    },
    "chooseOpponent": "Wähle deinen Gegner",
    "ratingsBucket": "Wertungen:",
    "onlinePlayers": "Spieler online",
    "loadingPlayers": "Spieler werden geladen...",
    "noPlayersOnline": "Gerade ist sonst niemand online",
    "reloadIn": "Aktualisierung in {{seconds}} s",
    "reloadInShort": "{{seconds}} s",
    "rematch": {
      "rematch": "Revanche",
      "accept": "Annehmen",
      "decline": "Ablehnen",
      "sessionScore": "Spielstand",
      "opponentWantsRematch": "Gegner möchte Revanche!",
      "declined": "Dein Gegner hat die Revanche abgelehnt",
      "expired": "Das Revanche-Angebot ist abgelaufen",
      "invite": {
        "incoming": "Revanche-Einladung",
        "tabBadge": "Revanche!",
        "message": "<b>{{name}}</b> ({{rating}}) möchte eine Revanche · <b>{{timeControl}}</b> · {{variant}}",
        "messageNoRating": "<b>{{name}}</b> möchte eine Revanche · <b>{{timeControl}}</b> · {{variant}}"
      },
      "waitingForOpponent": "Warte auf Gegner...",
      "newOpponent": "Zurück zur Startseite"
    },
    "match": {
      "legFirst": "Hinspiel",
      "legSecond": "Rückspiel",
      "legOf": "Partie {{leg}} von {{total}}",
      "legShort": "{{leg}}/{{total}}",
      "score": "Match",
      "returnStartsIn": "Das Rückspiel beginnt in {{seconds}}s",
      "leavingForfeits": "Wenn du jetzt gehst, verlierst du das Rückspiel kampflos.",
      "ratingAtMatchEnd": "Die Wertung wird am Ende des Matches aktualisiert.",
      "ready": "Bereit",
      "opponentReady": "Dein Gegner ist bereit",
      "waitingOpponent": "Warten auf den Gegner...",
      "complete": "Match beendet",
      "newMatch": "Neues Match",
      "twoLegsShort": "2 Partien"
    },
    "connectedCount": "{{count}} Online",
    "viewProfile": "Profil",
    "connessionePersa": {
      "titolo": "Verbindung verloren",
      "corpo": "Wir versuchen, dich zurück ans Brett zu bringen.",
      "riprova": "Erneut versuchen",
      "esci": "Verlassen"
    },
    "partitaFinitaMentreEriVia": "Die Partie endete, während du weg warst.",
    "sessioneAltrove": {
      "titolo": "Auf einem anderen Gerät geöffnet",
      "corpo": "Du hast das Spiel woanders geöffnet – hier kommen keine Züge und Herausforderungen mehr an.",
      "usaQui": "Hier verwenden"
    }
  },
  "lobby": {
    "title": "Spielen",
    "quickPlay": "Schnelles Spiel",
    "customGame": "Eigene Partie",
    "opponent": "Gegner",
    "opponentOnline": "Online (zufällig)",
    "opponentInPerson": "Vor Ort",
    "startInPerson": "Partie starten",
    "inPersonNote": "Zwei Spieler an einem Gerät. Zählt nicht für die Wertung.",
    "openTable": "Tisch öffnen",
    "openTables": "Wartende Tische",
    "noTablesInVariant": "Gerade ist kein Tisch in {{variant}} offen. Wähle eine Bedenkzeit für deinen eigenen.",
    "noTablesInVariantOrOther": "Gerade ist kein Tisch in {{variant}} offen. Wähle eine Bedenkzeit für deinen eigenen — oder nimm an einem Tisch einer anderen Variante Platz:",
    "otherVariants": "Andere Varianten",
    "sit": "Platz nehmen",
    "cancelTable": "Abbrechen",
    "waitingAtTable": "Warte auf einen Gegner",
    "inQueue": "In der Warteschlange",
    "tableExpired": "Dein Tisch ist nach 10 Minuten ohne Gegner abgelaufen. Öffne jederzeit einen neuen.",
    "customPosition": "Eigene Stellung",
    "errors": {
      "inCompetition": "Verlasse zuerst die Arena oder das Turnier.",
      "rateLimited": "Zu viele Tische. Warte einen Moment.",
      "tableGone": "Dieser Tisch ist nicht mehr verfügbar.",
      "hostGone": "Wer diesen Tisch geöffnet hat, ist nicht mehr da.",
      "ownTable": "Das ist dein eigener Tisch.",
      "invalidSettings": "Diese Einstellungen sind ungültig.",
      "startFailed": "Die Partie konnte nicht gestartet werden. Versuche es erneut.",
      "generic": "Etwas ist schiefgelaufen. Versuche es erneut."
    }
  },
  "spectate": {
    "watch": "Zuschauen",
    "watchPlayer": "Partie von {{username}} ansehen",
    "watchPair": "{{a}} gegen {{b}} ansehen",
    "watching": "Zuschauen",
    "leave": "Verlassen",
    "loading": "Partie wird geladen...",
    "turnWhite": "Weiß am Zug",
    "turnBlack": "Schwarz am Zug",
    "whiteWins": "Weiß gewinnt",
    "blackWins": "Schwarz gewinnt",
    "draw": "Remis",
    "gameOver": "Partie beendet",
    "betweenLegs": "Hinspiel beendet: das Rückspiel beginnt gleich",
    "unavailable": "Diese Partie ist nicht mehr verfügbar",
    "error": {
      "notPlaying": "Dieser Spieler ist nicht mehr in einer Partie.",
      "unavailable": "Diese Partie ist nicht mehr verfügbar.",
      "busy": "Du kannst keine Partie ansehen, während du selbst spielst.",
      "self": "Das ist deine eigene Partie — öffne sie über dein Brett."
    },
    "watchers": {
      "empty": "Niemand schaut gerade zu."
    }
  },
  "auth": {
    "signIn": "Anmelden",
    "signUp": "Registrieren",
    "preferredVariantHint": "Du kannst das jederzeit ändern",
    "createAccount": "Konto Erstellen",
    "noAccount": "Noch kein Konto?",
    "hasAccount": "Bereits ein Konto?",
    "fields": {
      "username": "Benutzername",
      "email": "E-Mail",
      "password": "Passwort",
      "confirmPassword": "Passwort Bestätigen",
      "emailOrUsername": "E-Mail oder Benutzername"
    },
    "placeholders": {
      "chooseUsername": "Benutzernamen wählen",
      "yourEmail": "deine@email.de",
      "atLeast8Chars": "Mindestens 8 Zeichen",
      "confirmYourPassword": "Passwort bestätigen",
      "enterEmailOrUsername": "E-Mail oder Benutzername eingeben",
      "yourPassword": "Dein Passwort"
    },
    "errors": {
      "passwordsNoMatch": "Passwörter stimmen nicht überein",
      "passwordTooShort": "Passwort muss mindestens 8 Zeichen haben",
      "usernameTooShort": "Benutzername muss mindestens 3 Zeichen haben",
      "passwordRequirements": "Passwort muss mindestens einen Großbuchstaben, einen Kleinbuchstaben und eine Zahl enthalten",
      "network": "Keine Internetverbindung. Überprüfe deine Verbindung und versuche es erneut.",
      "guestLoginFailed": "Die Gast-Sitzung konnte nicht gestartet werden. Prüfe deine Verbindung und versuche es erneut.",
      "guestLoginRateLimited": "Zu viele Gast-Anmeldungen aus diesem Netzwerk. Versuche es in ein paar Minuten erneut oder melde dich mit deinem Konto an."
    },
    "validation": {
      "usernameChars": "Nur Buchstaben, Zahlen und Unterstriche",
      "invalidEmail": "Gib eine gültige E-Mail-Adresse ein",
      "min8": "8+ Zeichen",
      "uppercase": "Großbuchstabe",
      "lowercase": "Kleinbuchstabe",
      "number": "Zahl"
    },
    "playAsGuest": "Als Gast spielen",
    "guestBanner": "Du spielst als Gast.",
    "guestBannerCta": "Registriere dich, um deinen Fortschritt zu speichern.",
    "guestUpgrade": "Konto erstellen",
    "guestRestriction": "Diese Funktion erfordert ein registriertes Konto",
    "guestCannotTournament": "Registriere dich, um an Turnieren teilzunehmen",
    "guestCannotChallenge": "Registriere dich, um Spieler herauszufordern",
    "forgotPassword": "Passwort vergessen?",
    "forgotPasswordDesc": "Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.",
    "sendResetLink": "Link senden",
    "resetEmailSent": "Überprüfe deine E-Mail",
    "checkSpam": "Nicht gefunden? Überprüfe deinen Spam-Ordner.",
    "backToLogin": "Zurück zur Anmeldung",
    "resetPassword": "Passwort zurücksetzen",
    "resetPasswordDesc": "Gib unten dein neues Passwort ein.",
    "newPassword": "Neues Passwort",
    "confirmPassword": "Passwort bestätigen",
    "resetSuccess": "Passwort erfolgreich aktualisiert. Du kannst dich jetzt anmelden.",
    "resetExpired": "Dieser Link ist abgelaufen. Bitte fordere einen neuen an.",
    "resetInvalid": "Ungültiger oder abgelaufener Link.",
    "verifyEmail": {
      "title": "Überprüfe deine E-Mail",
      "checkInbox": "Wir haben einen Bestätigungslink an {{email}} gesendet. Klicke auf den Link, um dein Konto zu aktivieren.",
      "spamHint": "Nicht gefunden? Überprüfe deinen Spam-Ordner.",
      "pageTitle": "E-Mail-Verifizierung",
      "verifying": "Deine E-Mail wird verifiziert...",
      "success": "E-Mail bestätigt. Dein Konto ist aktiv.",
      "successAndBack": "E-Mail bestätigt. Wir bringen dich zurück zum Turnier.",
      "verifyButton": "Meine E-Mail verifizieren",
      "error": "Verifizierung fehlgeschlagen. Bitte versuche es erneut.",
      "loginBlocked": "Bitte verifiziere deine E-Mail, bevor du dich anmeldest",
      "resendLink": "Bestätigungs-E-Mail erneut senden",
      "resendSent": "Bestätigungs-E-Mail gesendet!",
      "enterEmailToResend": "Melde dich mit deiner E-Mail-Adresse an, um die Bestätigung erneut zu senden",
      "wrongAddress": "Falsche Adresse?",
      "changeAddress": "Adresse korrigieren",
      "newAddressLabel": "Neue E-Mail-Adresse",
      "passwordLabel": "Das Passwort, das du gerade gewählt hast",
      "changeSubmit": "An die neue Adresse senden",
      "changeSent": "Wenn das Konto existiert und auf die Bestätigung wartet, haben wir den Link an die neue Adresse geschickt.",
      "changeFailed": "Die Adresse konnte nicht geändert werden. Versuche es in ein paar Minuten erneut."
    }
  },
  "profile": {
    "title": "Profil",
    "notFound": "Profil Nicht Gefunden",
    "userNotFound": "Benutzer nicht gefunden",
    "memberSince": "Mitglied seit {{date}}",
    "goBack": "Zurück",
    "loadingProfile": "Profil wird geladen...",
    "tabs": {
      "overview": "Übersicht",
      "games": "Spiele",
      "stats": "Statistiken"
    },
    "variants": {
      "all": "Alle"
    },
    "stats": {
      "rating": "Rating",
      "games": "Spiele",
      "wins": "Siege",
      "losses": "Niederlagen",
      "draws": "Unentschieden",
      "winRate": "Siegquote",
      "winRateShort": "Siegquote",
      "winLossBreakdown": "Siege · Remis · Niederlagen",
      "peakRating": "Bestwert",
      "streak": "Serie",
      "bestStreak": "Beste",
      "avgTime": "Durchschn. Zeit",
      "title": "Detaillierte Statistiken",
      "comingSoon": "Demnächst verfügbar...",
      "loading": "Statistiken werden geladen...",
      "noData": "Noch keine Spiele gespielt. Spiele ein paar Partien, um deine Statistiken zu sehen!",
      "byTimeControl": "Leistung nach Zeitkontrolle",
      "byVariant": "Leistung nach Variante",
      "byColor": "Leistung nach Farbe",
      "general": "Allgemein",
      "asWhite": "Als Weiß",
      "asBlack": "Als Schwarz",
      "totalGames": "Gesamt Spiele",
      "avgMoves": "Durchschnittliche Züge",
      "gamesShort": "Spiele",
      "mostActive": "Aktivste Spieler",
      "mostActiveEmpty": "Noch keine Partien in dieser Variante.",
      "viewFullLeaderboard": "Zur vollständigen Rangliste",
      "ratingEvolution": "Rating-Verlauf · letzte 30 Tage",
      "chartComingSoon": "Verlauf folgt",
      "peakShort": "Höchst",
      "barraEsito": "{{win}}% Siege, {{draw}}% Remis, {{loss}}% Niederlagen",
      "percentualeVittorie": "{{rate}}% Siegquote",
      "siglaVittorie": "S",
      "siglaPatte": "R",
      "siglaSconfitte": "N"
    },
    "games": {
      "today": "Heute",
      "yesterday": "Gestern",
      "daysAgo": "vor {{days}} Tagen",
      "weeksAgo": "vor {{weeks}}W",
      "moves": "Züge",
      "sourceArena": "Arena",
      "sourceTournament": "Turnier",
      "loading": "Spiele werden geladen...",
      "noGames": "Keine Spiele gefunden",
      "clearFilters": "Filter löschen",
      "clearFiltersActive": "Aktive Filter löschen",
      "loadMore": "Mehr laden",
      "showing": "{{count}} Spiele",
      "clickViewAll": "Klicken Sie auf \"Alle anzeigen\" für den Spielverlauf",
      "filterResult": "Ergebnis",
      "filterTimeControl": "Bedenkzeit",
      "filterVariant": "Variante",
      "filterOpponent": "Gegner",
      "filters": {
        "all": "Alle",
        "wins": "Siege",
        "draws": "Remis",
        "losses": "Niederlagen",
        "allVariants": "Alle Varianten",
        "allTimeControls": "Alle Zeitkontrollen",
        "vsMe": "Gegen mich"
      }
    },
    "challenge": "Herausfordern",
    "settings": "Einstellungen",
    "gameSettings": "Spieleinstellungen",
    "preferredVariant": "Bevorzugte Variante",
    "preferredCadence": "Bevorzugte Bedenkzeit",
    "accountSettings": "Konto",
    "audioHaptics": "Ton & Vibration",
    "changePassword": "Passwort ändern",
    "changePasswordSub": "Aktualisiere dein Passwort",
    "currentPassword": "Aktuelles Passwort",
    "newPassword": "Neues Passwort",
    "passwordChanged": "Passwort erfolgreich geändert",
    "analyticsLabel": "Analytische Cookies",
    "language": "Sprache",
    "country": "Land",
    "countryNone": "Nicht festgelegt",
    "logout": "Abmelden",
    "logoutSub": "Melde dich von deinem Konto ab",
    "exportData": "Meine Daten exportieren",
    "exportDataSub": "Lade ein JSON deiner Daten herunter",
    "deleteAccount": {
      "button": "Konto löschen",
      "sub": "Lösche dein Konto dauerhaft",
      "title": "Konto Löschen",
      "warning": "Diese Aktion ist dauerhaft und kann nicht rückgängig gemacht werden. Alle deine Daten werden gelöscht.",
      "confirmPassword": "Gib dein Passwort zur Bestätigung ein",
      "confirm": "Endgültig löschen",
      "error": "Konto konnte nicht gelöscht werden"
    },
    "graphics": {
      "title": "Grafik",
      "pieceShape": "Form der Steine",
      "pieceStyle": "Stil der Steine",
      "kingIcon": "Damen-Symbol",
      "pieceColor": "Farbe der Steine",
      "pieceColorAutoHint": "Die Steinfarben ändern sich je nach Variante.",
      "pieceMaterial": "Material der Steine",
      "boardColor": "Farbe des Bretts",
      "boardColorAutoHint": "Die Brettfarben ändern sich je nach Variante.",
      "boardMaterial": "Material des Bretts",
      "boardNotation": "Brettnotation",
      "notation": "Notation",
      "shapes": {
        "round": "Rund",
        "donut": "Donut",
        "square": "Quadrat",
        "rhombus": "Raute",
        "triangle": "Dreieck",
        "star": "Stern",
        "heart": "Herz"
      },
      "styles": {
        "3d-stacked-engraved": "3D gestapelt, graviert",
        "3d-stacked-smooth": "3D gestapelt, glatt",
        "3d-crown": "3D mit Krone",
        "flat-plain": "Flach, schlicht",
        "flat-engraved": "Flach, graviert"
      },
      "kingIcons": {
        "crown": "Krone",
        "ring": "Ring",
        "star": "Stern",
        "diamond": "Diamant",
        "none": "Keines"
      },
      "crownType": "Kronentyp",
      "crownTypes": {
        "classic": "Klassisch",
        "plain": "Schlicht",
        "diadem": "Diadem",
        "lily": "Lilienkrone",
        "imperial": "Kaiserlich"
      },
      "pieceColors": {
        "auto": "Auto (je Variante)",
        "custom": "Eigene…",
        "italian": "Italienisch",
        "international": "International",
        "english": "Englisch",
        "brazilian": "Brasilianisch",
        "classic": "Klassisch",
        "white-black": "Weiß/Schwarz",
        "red-black": "Rot/Schwarz",
        "blue-red": "Blau/Rot",
        "orange-blue": "Orange/Blau (farbenblind)",
        "silver-gold": "Silber/Gold",
        "coral-teal": "Koralle/Türkis",
        "green-purple": "Grün/Lila",
        "pink-navy": "Rosa/Marineblau"
      },
      "materials": {
        "plastic": "Kunststoff",
        "marble": "Marmor",
        "glass": "Glas",
        "wood": "Holz"
      },
      "boards": {
        "auto": "Auto (je Variante)",
        "custom": "Eigene…",
        "wood-classic": "International",
        "italian": "Italienisch",
        "english": "Englisch",
        "brazilian": "Brasilianisch",
        "walnut": "Walnuss",
        "green-cream": "Grün/Creme",
        "blue-grey": "Blau/Grau",
        "marble": "Marmor",
        "high-contrast": "Hoher Kontrast",
        "mahogany": "Mahagoni",
        "ocean": "Ozean",
        "purple-lavender": "Violett/Lavendel",
        "rose": "Rosé"
      },
      "notations": {
        "none": "Keine",
        "numeric": "Zahlen",
        "algebraic": "Koordinaten"
      },
      "hue": "Farbton",
      "customPieceLight": "Helle Steine",
      "customPieceDark": "Dunkle Steine",
      "customBoardLight": "Helle Felder",
      "customBoardDark": "Dunkle Felder",
      "picker": {
        "edit": "Farben bearbeiten",
        "hex": "Hex",
        "area": "Sättigung und Helligkeit",
        "saturation": "Sättigung",
        "brightness": "Helligkeit",
        "tooClose": "Diese beiden Farben sind sehr ähnlich — Steine oder Felder könnten schwer zu unterscheiden sein."
      },
      "uiTheme": "App-Design",
      "themes": {
        "light": "Hell",
        "dark": "Dunkel"
      }
    },
    "game": {
      "title": "Spiel",
      "moveSound": "Ton für Züge aktivieren",
      "lowTimeSound": "Ton bei wenig Zeit aktivieren",
      "notificationSound": "Ton für Meldungen aktivieren",
      "vibration": "Vibration für Züge aktivieren"
    },
    "gameplay": {
      "title": "Spielablauf",
      "showMoveHints": "Mögliche Züge anzeigen",
      "showLastMove": "Letzten Zug hervorheben",
      "showLastMoveCaptures": "Schlagzüge hervorheben",
      "premove": "Vorzüge aktivieren"
    },
    "avatar": {
      "title": "Wähle einen Avatar",
      "choose": "Verfügbare Avatare",
      "remove": "Kein Avatar",
      "edit": "Avatar ändern",
      "presets": {
        "crown": "Krone",
        "star": "Stern",
        "flame": "Flamme",
        "zap": "Blitz",
        "shield": "Schild",
        "rocket": "Rakete",
        "gem": "Edelstein",
        "leaf": "Blatt",
        "moon": "Mond",
        "sun": "Sonne",
        "heart": "Herz",
        "ghost": "Geist"
      }
    },
    "viewProfileOf": "Profil von {{username}} ansehen",
    "report": {
      "trigger": "{{username}} melden",
      "title": "{{username}} melden",
      "intro": "Sag uns, was mit diesem Profil nicht stimmt. Ein Moderator wird es prüfen.",
      "reasonLabel": "Grund",
      "reasons": {
        "offensive_username": "Beleidigender Benutzername",
        "offensive_avatar": "Beleidigendes Profilbild",
        "harassment": "Belästigung oder Drohungen",
        "spam": "Spam oder Werbung",
        "other": "Sonstiges"
      },
      "noteLabel": "Details (optional)",
      "notePlaceholder": "Alles, was uns beim Verstehen hilft",
      "privacyHint": "Die Meldung wird {{days}} Tage zur Moderation gespeichert. Das Profil ist öffentlich: wir speichern keine Kopie davon.",
      "submit": "Meldung senden",
      "sending": "Senden...",
      "done": "Meldung gesendet. Danke.",
      "errors": {
        "duplicate": "Du hast diesen Spieler bereits gemeldet. Ein Moderator prüft es.",
        "notFound": "Dieser Spieler ist nicht mehr verfügbar.",
        "self": "Du kannst dich nicht selbst melden.",
        "registeredOnly": "Für eine Meldung von hier brauchst du ein registriertes Konto.",
        "rateLimited": "Zu viele Meldungen. Bitte versuche es später erneut.",
        "generic": "Die Meldung konnte nicht gesendet werden. Bitte versuche es erneut."
      }
    }
  },
  "gamesHistory": {
    "title": "Spielverlauf",
    "gamesPlayed": "{{count}} Spiele gespielt",
    "noGames": "Noch keine Spiele. Spiele online, um sie hier zu sehen!",
    "signInToView": "Melde dich an, um deinen Spielverlauf zu sehen.",
    "loadingGames": "Spiele werden geladen...",
    "loadingGame": "Spiel wird geladen...",
    "failedToLoad": "Spiele konnten nicht geladen werden",
    "moves": "{{count}} Züge"
  },
  "replay": {
    "backToGames": "Zurück zu Spielen",
    "loadFailed": "Diese Partie konnte nicht geöffnet werden. Bitte versuche es erneut.",
    "result": {
      "whiteWins": "Weiß gewinnt",
      "blackWins": "Schwarz gewinnt",
      "draw": "Unentschieden"
    },
    "controls": {
      "goToStart": "Zum Anfang",
      "previousMove": "Vorheriger Zug",
      "nextMove": "Nächster Zug",
      "goToEnd": "Zum Ende",
      "play": "Abspielen",
      "pause": "Pause",
      "showMoves": "Züge anzeigen",
      "hideMoves": "Züge ausblenden",
      "position": "Position in der Partie"
    },
    "downloadPdn": "PDN Herunterladen",
    "openInEditor": "Im Editor studieren",
    "share": "Teilen",
    "shareCopied": "Link kopiert!",
    "shareTitle": "Dame-Partie",
    "shareText": "Sieh dir diese Dame-Partie an",
    "shareSheet": {
      "pdnTitle": "PDN herunterladen",
      "withNotes": "Mit meinen Notizen ({{count}})",
      "withoutNotes": "Ohne Notizen",
      "pdnIntro": "Die Notizen werden zu Kommentaren in der PDN-Datei."
    }
  },
  "review": {
    "save": {
      "save": "Partie speichern",
      "saved": "Gespeichert",
      "title": "Partie speichern",
      "intro": "Wähle einen Ordner, um diese Partie wiederzufinden.",
      "confirm": "Speichern",
      "remove": "Aus Gespeicherten entfernen",
      "error": "Die Partie konnte nicht gespeichert werden"
    },
    "folders": {
      "unsorted": "Ohne Ordner",
      "newLabel": "Neuer Ordner",
      "newPlaceholder": "Name des Ordners",
      "create": "Erstellen",
      "duplicate": "Ein Ordner mit diesem Namen existiert bereits",
      "rename": "Umbenennen",
      "renameFolder": "„{{name}}“ umbenennen",
      "renameLabel": "Neuer Name des Ordners",
      "renameError": "Der Ordner konnte nicht umbenannt werden",
      "delete": "Löschen",
      "deleteFolder": "„{{name}}“ löschen",
      "deleteConfirm": "Löschen?",
      "deleteHint": "Die Partien werden nicht gelöscht: sie kommen zurück nach „Ohne Ordner“.",
      "deleteError": "Der Ordner konnte nicht gelöscht werden",
      "filterLabel": "Ordner",
      "savedOnly": "Nur gespeicherte",
      "gameCount_one": "{{count}} Partie",
      "gameCount_other": "{{count}} Partien"
    },
    "notes": {
      "add": "Notiz hinzufügen",
      "atStart": "Notiz zur Ausgangsstellung",
      "atMove": "Notiz bei Zug {{ply}}",
      "placeholder": "Schreibe eine Notiz zu dieser Stellung…",
      "save": "Notiz speichern",
      "delete": "Notiz löschen",
      "jumpTo": "Zur Notiz bei Zug {{ply}} springen",
      "error": "Die Notiz konnte nicht gespeichert werden",
      "hasNote": "Diese Stellung hat eine Notiz"
    }
  },
  "leaderboard": {
    "title": "Rangliste",
    "subtitle": "Top 100 Spieler",
    "loading": "Rangliste wird geladen...",
    "empty": "Noch keine Spieler mit abgeschlossenen Spielen.",
    "allTime": "Rating",
    "mostGames": "Aktivste",
    "bullet": "Bullet",
    "blitz": "Blitz",
    "rapid": "Rapid",
    "classical": "Klassisch",
    "columns": {
      "rank": "#",
      "player": "Spieler",
      "rating": "Rating",
      "class": "Klasse",
      "games": "Spiele",
      "days": "Tage",
      "record": "Rekord"
    },
    "period": {
      "label": "Tage",
      "days": "{{days}} Tage",
      "all": "Gesamt"
    },
    "emptyPeriod": "Keine Spiele in dieser Variante in den letzten {{days}} Tagen.",
    "emptyStreak": "Zurzeit hat niemand einen aktiven Streak.",
    "classes": {
      "novice": "Anfänger",
      "intermediate": "Mittelstufe",
      "advanced": "Fortgeschritten",
      "expert": "Experte",
      "master": "Meister",
      "grandmaster": "Großmeister",
      "legend": "Legende"
    }
  },
  "tournament": {
    "title": "Turniere",
    "subtitle": "Teste deine Fähigkeiten in kompetitiven Turnieren",
    "list": {
      "heroTitle": "Die Turniere",
      "arenasLink": "Alle Arenen ansehen",
      "archive_one": "Das letzte beendete Turnier.",
      "archive_other": "Die letzten {{count}} beendeten Turniere."
    },
    "createTournament": "Turnier erstellen",
    "formats": {
      "arena": "Arena",
      "italoSwiss": "Rundenturnier/Schweizer (je nach Teilnehmerzahl)",
      "swiss": "Schweizer System",
      "roundRobin": "Round Robin (jeder gegen jeden)",
      "arenaShort": "Arena",
      "italoSwissShort": "Rundenturnier/Schweizer",
      "swissShort": "Schweizer",
      "roundRobinShort": "Rundenturnier"
    },
    "filters": {
      "all": "Alle",
      "live": "Live",
      "upcoming": "Kommend",
      "variant": "Variante",
      "status": "Status",
      "international": "International",
      "italian": "Italienisch",
      "english": "Englisch",
      "brazilian": "Brasilianisch",
      "comingSoon": "Demnächst",
      "owner": "Turniere",
      "mine": "Meine"
    },
    "sections": {
      "live": "Laufend",
      "upcoming": "Kommend",
      "finished": "Beendet"
    },
    "status": {
      "live": "LIVE",
      "upcoming": "KOMMEND",
      "finished": "BEENDET",
      "scheduled": "GEPLANT",
      "cancelled": "ABGESAGT"
    },
    "card": {
      "rated": "Gewertet",
      "registered": "Angemeldet",
      "gamesPlayed_one": "{{count}} Spiel gespielt",
      "gamesPlayed_other": "{{count}} Spiele gespielt",
      "players_one": "{{count}} Spieler",
      "players_other": "{{count}} Spieler",
      "starts": "Start {{time}}",
      "startsAt": "Beginnt um {{time}}",
      "startsAtTomorrow": "Beginnt morgen um {{time}}",
      "startsAtDate": "Beginnt am {{date}} um {{time}}",
      "startsInCountdown": "Beginnt in {{time}}",
      "startingNow": "Beginnt jetzt!",
      "privateHint": "Privates Turnier: Du brauchst eine Einladung oder das Passwort",
      "publicHint": "Öffentliches Turnier: für alle offen",
      "private": "Privat",
      "seats": "Plätze",
      "yourPlace": "du {{rank}}.",
      "gettoneAlle": "Beginnt um",
      "gettoneDomani": "Morgen um",
      "gettoneData": "{{date}} um",
      "gettoneTra": "Beginnt in",
      "gettoneMin": "Min."
    },
    "games": {
      "allGames": "Alle Partien",
      "myGames": "Meine Partien",
      "noGames": "Noch keine Partien gespielt",
      "moves": "Züge",
      "analyze": "Analysieren",
      "round": "Runde {{n}}"
    },
    "participants": {
      "sortByScore": "Nach Punkten",
      "sortByRating": "Nach Rating",
      "sortByName": "A-Z",
      "status": {
        "playing": "Spielt",
        "online": "Online",
        "offline": "Offline"
      }
    },
    "matchFound": {
      "title": "Gegner gefunden!",
      "opponent": "Gegner",
      "playAsWhite": "Du spielst Weiß",
      "playAsBlack": "Du spielst Schwarz",
      "startingIn": "Start in...",
      "startNow": "Jetzt starten"
    },
    "postGame": {
      "currentRank": "Aktuelle Platzierung",
      "continue": "Weiter"
    },
    "empty": {
      "live": "Momentan keine Live-Turniere.",
      "upcoming": "Keine kommenden Turniere geplant.",
      "all": "Keine Turniere verfügbar.",
      "mine": "Du hast noch keine Turniere. Erstelle eins oder tritt mit einer Einladung bei.",
      "finished": "Noch keine beendeten Turniere.",
      "goLive": "Laufende ansehen",
      "goUpcoming": "Kommende ansehen",
      "goFinished": "Archiv ansehen"
    },
    "loading": "Turniere werden geladen...",
    "notFound": "Turnier nicht gefunden",
    "detail": {
      "timeControl": "Zeitkontrolle",
      "duration": "Dauer",
      "players": "Spieler",
      "games": "Spiele",
      "startsIn": "Start {{time}}",
      "joinTournament": "Turnier Beitreten",
      "register": "Anmelden",
      "unregister": "Abmelden",
      "leaveTournament": "Turnier Verlassen",
      "yourStats": "Deine Statistiken",
      "points": "Punkte",
      "rank": "Rang",
      "askPassword": "Turnierpasswort",
      "share": "Einladung teilen",
      "shareStandings": "Tabelle teilen",
      "shareCopied": "Link kopiert",
      "cancelTournament": "Turnier absagen",
      "cancelConfirm": "Das Turnier verschwindet und alle Angemeldeten werden benachrichtigt. Das lässt sich nicht rückgängig machen.",
      "cancelYes": "Ja, absagen",
      "cancelNo": "Nein, behalten",
      "createdBy": "Erstellt von {{username}}",
      "regenerate": "Neue Zugangsdaten",
      "regenerateHint": "Der alte Link funktioniert nicht mehr. Wähle ein neues Passwort und verschicke die Einladung erneut.",
      "regenerateNewPassword": "Neues Passwort",
      "regenerateConfirm": "Neue Zugangsdaten erstellen",
      "regenerateCancel": "Abbrechen",
      "regenerateDone": "Neue Zugangsdaten erstellt: der alte Link gilt nicht mehr",
      "ratingFloor": "Mindestwertung",
      "aiutoAssenza": "Was passiert, wenn ich nicht spiele?",
      "aiutoApertura": "Warum beginnen manche Partien mit schon gespielten Zügen?",
      "formatoTitolo": "Wie das Format entschieden wird",
      "formatoOraGirone": "Mit den jetzt Angemeldeten ({{n}}) wäre es ein Rundenturnier.",
      "formatoOraSvizzero": "Mit den jetzt Angemeldeten ({{n}}) wäre es ein Schweizer System.",
      "formatoOraPochi": "Zum Start braucht es mindestens {{min}} Anmeldungen: jetzt sind es {{n}}.",
      "formatoPrevisto": "Erwartet",
      "seSvizzero": "Bei Schweizer System",
      "seGirone": "Bei Rundenturnier",
      "punteggio": "Punktesystem"
    },
    "scoring": {
      "title": "Arena Punktesystem",
      "win": "Sieg: +{{points}}",
      "draw": "Unentschieden: +{{points}}"
    },
    "standings": {
      "title": "Rangliste",
      "liveStandings": "Live Rangliste",
      "empty": "Noch keine Spieler. Sei der Erste!",
      "morePlayers_one": "+ {{count}} weiterer Spieler",
      "morePlayers_other": "+ {{count}} weitere Spieler",
      "columns": {
        "rank": "#",
        "player": "Spieler",
        "points": "Punkte",
        "status": "Status",
        "winsDrawsLosses": "S/R/N",
        "winsDrawsLossesByes": "S/R/N/F",
        "byes": "Frei"
      },
      "status": {
        "playing": "Spielt",
        "ready": "Bereit",
        "paused": "Pausiert",
        "left": "Raus",
        "offline": "Offline",
        "assente": "Abwesend",
        "haFinito": "Wartet",
        "riposa": "Setzt aus",
        "disconnesso": "Getrennt"
      },
      "tied": "Punktgleich",
      "tiebreakHelp": "Wie wird bei Punktgleichheit entschieden?",
      "sdSigla": "DV",
      "sdSpiega": "Vor {{nomi}} durch den direkten Vergleich unter den Punktgleichen",
      "scoreSheet": {
        "label": "Verlauf: {{esiti}}",
        "outcome": {
          "win": "gewonnen",
          "winPlus": "gewonnen, mehr wert",
          "draw": "remis",
          "loss": "verloren",
          "bye": "spielfrei"
        },
        "clipped": "die ältesten bleiben links außen",
        "hint": "Alle Partien, neueste rechts",
        "hintRiposoSvizzero": "das Quadrat ist eine spielfreie Runde und zählt wie ein Sieg",
        "hintRiposoGirone": "das Quadrat ist eine spielfreie Runde und bringt keine Punkte"
      }
    },
    "lobby": {
      "leaveTournament": "Turnier Verlassen",
      "waitingForOpponent": "Warte auf Gegner...",
      "pts": "Pkt",
      "rank": "Rang",
      "yourPosition": "Deine Position"
    },
    "timer": {
      "remaining": "Verbleibend",
      "finished": "Beendet",
      "started": "Gestartet",
      "daysHours": "{{days}}T {{hours}}Std"
    },
    "tabs": {
      "standings": "Rangliste",
      "games": "Spiele",
      "details": "Details",
      "participants": "Teilnehmer",
      "gamesPlaceholder": "Aktuelle Spiele erscheinen hier"
    },
    "rules": {
      "title": "Punkteregeln"
    },
    "create": {
      "title": "Turnier erstellen",
      "infoAbout": "Infos zu {{campo}}",
      "nameLabel": "Turniername *",
      "namePlaceholder": "z.B. Sonntags Blitz Arena",
      "nameRequired": "Turniername ist erforderlich",
      "aperturaUnicaHint": "Eine einzige Eröffnung für alle Runden und alle Partien des Turniers — nützlich für ein Thementurnier zu einer einzelnen Eröffnung",
      "aperturaUnicaScelta": "Nr. {{id}}",
      "aperturaUnicaScegli": "Eröffnung wählen",
      "aperturaUnicaMancante": "Wähle eine Eröffnung, um fortzufahren",
      "aperturaUnicaAmichevole": "Diese Eröffnung ist zu einseitig, als dass eine einzelne Partie sie ausgleichen könnte: das Turnier ist freundschaftlich. Mit Hin- und Rückspiel bleibt es gewertet.",
      "nameLength": "Name muss 3-100 Zeichen haben",
      "descriptionLabel": "Beschreibung (optional)",
      "descriptionPlaceholder": "Beschreibe dein Turnier...",
      "timeControlLabel": "Zeitkontrolle",
      "durationLabel": "Dauer",
      "startsAtLabel": "Startzeit",
      "startsAtRange": "Von 5 Minuten bis 14 Tage ab jetzt.",
      "startsAtInvalid": "Wähle eine Zeit zwischen 5 Minuten und 14 Tagen ab jetzt.",
      "visibilityLabel": "Sichtbarkeit",
      "visibilityPublic": "Öffentlich",
      "visibilityPrivate": "Privat",
      "passwordLabel": "Turnierpasswort",
      "passwordHint": "Du kannst es später wieder nachlesen, um es zu teilen. Nimm nicht dein Kontopasswort.",
      "passwordRequired": "Ein privates Turnier braucht ein Passwort",
      "estimate": "{{players}} Spieler, {{rounds}} Runden → etwa {{duration}}, Ende gegen {{end}}",
      "estimateRange": "{{players}} Spieler, {{roundsMin}} bis {{roundsMax}} Runden → etwa {{duration}}, Ende spätestens {{end}}",
      "durationOptions": {
        "30min": "30 Min",
        "1hour": "1 Stunde",
        "1.5hours": "1,5 Stunden",
        "2hours": "2 Stunden",
        "3hours": "3 Stunden"
      },
      "minRatingLabel": "Min Rating",
      "maxRatingLabel": "Max Rating",
      "ratedLabel": "Gewertet",
      "ratingFloorLabel": "Mindestwertung",
      "ratingFloorHint": "Unter dieser Wertung ist keine Teilnahme möglich. Gemessen wird die Wertung für Variante und Zeitkontrolle dieses Turniers: wer diese Kombination noch nie gespielt hat, gilt als Neuling. Nur bei gewerteten Turnieren.",
      "ratingFloorNone": "Keine",
      "variantLabel": "Variante",
      "variantInternational": "International (10×10)",
      "variantItalian": "Italienisch (8×8)",
      "variantEnglish": "Englisch (8×8)",
      "formatLabel": "Format",
      "maxPlayersLabel": "Max. Spieler",
      "thresholdLabel": "Schweizer ab",
      "thresholdHint": "Ab {{n}} Teilnehmern wird nach Schweizer System gespielt, darunter als Rundenturnier. Die Rundenzahl legt der Start fest, anhand der tatsächlich Erschienenen. Bei drei oder vier Teilnehmern wird das Rundenturnier auch mit Rückrunde gespielt: weiterhin drei Runden, aber mit je zwei Partien, denn eine Partie pro Gegner wäre zu wenig.",
      "extraRoundLabel": "Zusatzrunden (Schweizer System)",
      "extraRoundHint": "Eine oder zwei Runden mehr als die Tabelle vorgibt, soweit das Feld sie trägt. Im Rundenturnier ändert sich nichts: dort trifft jeder auf jeden, und eine Runde mehr wäre für alle eine Revanche.",
      "extraRoundsNone": "Keine",
      "extraRoundsOne": "+1 Runde",
      "extraRoundsTwo": "+2 Runden",
      "tooLongWarningSeats": "Mehr als ein Tag Spielzeit: nimm Plätze weg oder verkürze die Bedenkzeit.",
      "minPlayersLabel": "Min. Spieler",
      "minPlayersHint": "Unter dieser Zahl sagt sich das Turnier zur Startzeit selbst ab. Je höher du sie setzt, desto wahrscheinlicher ist das.",
      "seatsWarning": "Über dieser Zahl kommt niemand mehr hinein, und du kannst sie später nicht mehr ändern.",
      "submitButton": "Turnier Erstellen",
      "submitting": "Erstellen...",
      "failedToCreate": "Turnier konnte nicht erstellt werden",
      "arenaHint": "Eine Arena hat keine Runden: Du wirst fortlaufend gepaart, bis die Zeit abläuft.",
      "arenaDurationHint": "Wie lange die Arena geöffnet bleibt. Höchstens acht Stunden.",
      "arenaSummary": "Arena über {{duration}}, Ende gegen {{end}}",
      "twoLegLabel": "Hin- und Rückspiel",
      "twoLegHint": "Jede Paarung wird zweimal hintereinander gespielt, mit vertauschten Farben.",
      "twoLegItaloHint": "Dieselben zwei Spieler treffen in derselben Runde zweimal aufeinander, mit vertauschten Farben und derselben Eröffnung: die Runde dauert doppelt so lange, die Rundenzahl verdoppelt sich nicht. Bei drei oder vier Teilnehmern wird die Rückrunde immer gespielt, unabhängig von diesem Schalter.",
      "boostLabel": "Boost",
      "boostHint": "Wer spielt, kann wetten: Man gibt die Hälfte der Grundzeit und das Inkrement auf, und ein Sieg zählt doppelt. Er wird vor dem eigenen ersten Zug genommen. Ausgeschaltet nutzt ihn in dieser Arena niemand.",
      "roundsHelp": "Wie viele Runden werden gespielt?"
    },
    "signInToJoin": "Melde dich an, um Turnieren beizutreten",
    "roundRobin": {
      "scontroDiretto": "Direkter Vergleich unter den punktgleichen Spielern (in der Tabelle «DV»)",
      "tiebreakerInfo": "Tiebreaker: Siege, direkter Vergleich, Sonneborn-Berger, Ratingänderung im Turnier"
    },
    "swiss": {
      "roundOf": "Runde {{current}} von {{total}}",
      "scoringWin": "Sieg: +{{points}}",
      "scoringDraw": "Remis: +{{points}}",
      "scoringLoss": "Niederlage: {{points}}",
      "buchholz": "BH",
      "sb": "SB",
      "variazione": "Δ",
      "variazioneTitolo": "Ratingänderung im Turnier",
      "criterioVittorie": "Zahl der Siege",
      "tiebreakersTitle": "Feinwertung",
      "buchholzCut1": "Buchholz (Cut 1)",
      "sonnebornBerger": "Sonneborn-Berger (SB)",
      "cannotJoinInProgress": "Dieses Swiss-Turnier läuft bereits. Du kannst nicht mehr beitreten.",
      "returnLegPending": "Das Rückspiel beginnt gleich: dieselben Gegner, vertauschte Farben.",
      "waitingBetweenRounds": "Warte auf nächste Runde...",
      "waitingFinalResults": "Warte auf die Endergebnisse...",
      "waitingForRoundEnd": "Warte auf Rundenende...",
      "tiebreakerInfo": "Tiebreaker: Buchholz Cut 1, Sonneborn-Berger, Siege, Ratingänderung im Turnier",
      "byeRoundPunti": "Diese Runde setzt du aus: +{{punti}} Punkte, schon in der Tabelle.",
      "byeRoundNessunPunto": "Diese Runde setzt du aus: im Rundenturnier bringt das Freilos keine Punkte.",
      "byeProssimoTurno": "Die nächste Runde beginnt von selbst, wenn die anderen Partien fertig sind.",
      "byeUltimoTurno": "Die Endergebnisse kommen, wenn die anderen Partien fertig sind.",
      "returnLegTra": "Das Rückspiel beginnt in {{secondi}} s: dieselben Gegner, vertauschte Farben.",
      "partiteConcluse": "Beendete Partien: {{completate}} von {{totali}}",
      "turnoParteDaSolo": "Die nächste Runde startet von selbst",
      "nonCiSiRitira": "Nach dem Start kann man sich nicht zurückziehen: wer nicht spielt, bleibt gepaart und verliert seine Partien auf Zeit."
    },
    "errors": {
      "authRequired": "Melde dich an, um an einem Turnier teilzunehmen.",
      "guestNotAllowed": "Turniere sind für registrierte Konten.",
      "notAllowed": "Nicht erlaubt.",
      "notFound": "Dieses Turnier existiert nicht mehr.",
      "userNotFound": "Spieler nicht gefunden.",
      "invalidInput": "Ungültige Anfrage.",
      "rateLimited": "Zu viele Anfragen — warte einen Moment.",
      "joinFailed": "Beitritt fehlgeschlagen. Versuche es erneut.",
      "arenaPiena": "Diese Arena ist voll: es sind keine Plätze mehr frei.",
      "arenaChiusa": "Diese Arena nimmt keine Anmeldungen mehr an.",
      "giaIscritto": "Du bist bereits in dieser Arena.",
      "arenaAnnullata": "Diese Arena wurde abgesagt: zur Startzeit waren zu wenige Spieler angemeldet.",
      "notJoinable": "Dieses Turnier nimmt keine neuen Anmeldungen an.",
      "roundsStarted": "Die Runde hat schon begonnen.",
      "ratingTooLow": "Deine Wertung liegt unter dem Minimum dieses Turniers.",
      "wrongFormat": "Turnierformat passt nicht.",
      "privateTournament": "Dieses Turnier ist privat: Du brauchst den Link oder das Passwort.",
      "wrongPassword": "Falsches Passwort.",
      "tooManyAttempts": "Zu viele Versuche. Versuch es in einer Viertelstunde erneut.",
      "tournamentFull": "Das Turnier ist voll.",
      "alreadyHasLive": "Du hast bereits 3 laufende Wettbewerbe: Du kannst einen neuen eröffnen, sobald einer davon endet.",
      "nameTaken": "Zu dieser Zeit gibt es bereits ein Turnier mit diesem Namen.",
      "startTooSoon": "Zu früh: Lass mindestens fünf Minuten, um jemanden einzuladen.",
      "startTooFar": "Zu weit weg: höchstens zwei Wochen ab jetzt.",
      "notOrganizer": "Das kann nur, wer das Turnier eröffnet hat.",
      "alreadyStarted": "Das Turnier läuft bereits.",
      "tooLong": "Das Turnier würde länger als einen Tag dauern: nimm Runden weg oder verkürze die Bedenkzeit.",
      "cancelledByOrganizer": "Der Veranstalter hat dieses Turnier abgesagt.",
      "cancelledNoPlayers": "Das Turnier wurde abgesagt: zu wenige Anmeldungen.",
      "serverError": "Serverfehler. Versuche es später erneut.",
      "offline": "Du scheinst offline zu sein — prüfe die Verbindung.",
      "timeout": "Der Server hat nicht geantwortet. Versuche es erneut.",
      "loadFailed": "Turniere konnten nicht geladen werden.",
      "notYourTurn": "Du bist nicht am Zug.",
      "drawOfferFailed": "Remis konnte nicht angeboten werden.",
      "unknown": "Etwas ist schiefgelaufen. Versuche es erneut.",
      "moveRejected": "Der Server hat deinen Zug abgelehnt: das Brett ist wieder wie vorher.",
      "partitaSvanita": "Die Partie ist nicht mehr auf dem Server: er wurde wahrscheinlich neu gestartet. Du bist zurück in der Turnier-Lobby.",
      "notInTournament": "Du bist für dieses Turnier nicht angemeldet.",
      "tournamentFullWayOut": "Andere Turniere und Arenen ansehen",
      "notPrivate": "Dieses Turnier ist öffentlich: Es gibt keine Zugangsdaten zu erneuern",
      "samePassword": "Das neue Passwort ist dasselbe wie das alte",
      "tournamentCancelled": "Das Turnier wurde abgesagt.",
      "inviteLinkExpired": "Dieser Einladungslink gilt nicht mehr: Tritt mit dem Passwort bei."
    },
    "ended": {
      "title": "Turnier beendet",
      "winner": "Sieger",
      "noWinner": "Kein Sieger: es wurden keine Partien gespielt.",
      "tiedWith": "Punktgleich auf Platz eins mit {{players}}"
    },
    "share": {
      "title": "Dame-Turnier",
      "text": "Du bist zum Turnier {{nome}} auf draughtsgame.com eingeladen",
      "standingsTitle": "Endstand — {{nome}}"
    }
  },
  "chat": {
    "title": "Chat",
    "openChat": "Chat öffnen",
    "closeChat": "Chat schließen",
    "empty": "Noch keine Nachrichten. Sag Hallo!",
    "placeholder": "Nachricht eingeben...",
    "unavailable": "Chat nicht verfügbar",
    "opponentLeft": "Dein Gegner hat die Partie verlassen.",
    "rateLimited": "Du schreibst zu schnell: Warte ein paar Sekunden.",
    "closingIn": "Der Chat schließt in {{seconds}}s",
    "closed": "Der Chat dieser Partie ist geschlossen.",
    "guestHint": "Gäste können Schnellreaktionen senden. Registriere dich für den vollen Chat.",
    "report": {
      "trigger": "Melden",
      "title": "{{username}} melden",
      "intro": "Erzähl uns, was passiert ist. Ein Moderator prüft den Chat dieser Partie.",
      "quoteLabel": "Letzte Nachricht von {{username}}",
      "reasonLabel": "Grund",
      "reasons": {
        "insult": "Beleidigungen oder anstößige Sprache",
        "harassment": "Belästigung oder Drohungen",
        "hate_speech": "Hassrede oder Diskriminierung",
        "spam": "Spam oder Werbung",
        "other": "Etwas anderes"
      },
      "noteLabel": "Details (optional)",
      "notePlaceholder": "Alles, was uns hilft, es zu verstehen",
      "privacyHint": "Der Chat dieser Partie (bis zu 100 Nachrichten, von beiden Spielern) wird zur Moderation gespeichert und {{days}} Tage aufbewahrt.",
      "submit": "Meldung senden",
      "sending": "Wird gesendet...",
      "done": "Meldung gesendet. Danke.",
      "muted": "Du hast diesen Spieler gemeldet. Seine Nachrichten sind ausgeblendet.",
      "errors": {
        "gone": "Diese Partie ist beendet und ihr Chat lässt sich nicht mehr überprüfen. Schreib uns über die Hilfe-Seite.",
        "duplicate": "Du hast diesen Spieler für diese Partie bereits gemeldet.",
        "notReportable": "Dieser Gegner kann nicht gemeldet werden.",
        "notInGame": "Du spielst diese Partie nicht.",
        "rateLimited": "Zu viele Meldungen. Bitte versuche es später erneut.",
        "generic": "Die Meldung konnte nicht gesendet werden. Bitte versuche es erneut."
      }
    },
    "quickPhrases": "Schnelle Sätze",
    "presets": {
      "hello": "Hallo!",
      "goodLuck": "Gutes Spiel!",
      "haveFun": "Viel Spaß!",
      "goodGame": "Gut gespielt!",
      "untilNext": "Bis zum nächsten Mal!",
      "thanks": "Danke!"
    }
  },
  "landing": {
    "nav": {
      "title": "Dama Online",
      "play": "Spielen",
      "tournaments": "Turniere",
      "learn": "Lernen",
      "community": "Community",
      "login": "Anmelden"
    },
    "hero": {
      "badge": "Das Ultimative Dame-Erlebnis",
      "title": "Werde ein Dame-Meister",
      "subtitle": "Spiele gegen Spieler weltweit, nimm an Turnieren teil und verbessere deine Fähigkeiten mit unseren fortschrittlichen Trainingstools.",
      "playFree": "Jetzt Spielen",
      "watchDemo": "Demo Ansehen"
    },
    "stats": {
      "players": "Aktive Spieler",
      "games": "Gespielte Partien",
      "variants": "Spielvarianten",
      "tournaments": "Tägliche Turniere"
    },
    "features": {
      "title": "Warum Dama Online?",
      "subtitle": "Alles was du brauchst, um ein Dame-Meister zu werden",
      "variants": {
        "title": "Mehrere Varianten",
        "description": "Spiele Italienisch, International, Englisch und Brasilianisch Dame - alles auf einer Plattform."
      },
      "matchmaking": {
        "title": "Intelligentes Matchmaking",
        "description": "Unser Glicko-2 Bewertungssystem sorgt für faire und wettbewerbsfähige Partien."
      },
      "tournaments": {
        "title": "Arena Turniere",
        "description": "Kämpfe in täglichen Turnieren mit Spielern aus aller Welt."
      },
      "ai": {
        "title": "KI Training",
        "description": "Trainiere gegen unsere fortschrittliche KI mit mehreren Schwierigkeitsstufen."
      },
      "analysis": {
        "title": "Spielanalyse",
        "description": "Überprüfe deine Partien und lerne aus deinen Fehlern mit detaillierter Analyse."
      },
      "community": {
        "title": "Aktive Community",
        "description": "Tritt Clubs bei, chatte mit Spielern und finde Freunde, die deine Leidenschaft teilen."
      }
    },
    "variants": {
      "title": "Spiele Deine Lieblingsvariante",
      "subtitle": "Wir unterstützen die beliebtesten Dame-Varianten aus aller Welt",
      "pieces": "Steine",
      "italian": "Italienisches Dame",
      "international": "Internationales Dame",
      "english": "Englisches Dame",
      "brazilian": "Brasilianisches Dame"
    },
    "testimonials": {
      "1": {
        "name": "Marco B.",
        "role": "Turnierspieler",
        "text": "Die beste Dame-Plattform, die ich je benutzt habe. Das Matchmaking ist fair und die Turniere sind aufregend!"
      },
      "2": {
        "name": "Elena V.",
        "role": "Gelegenheitsspieler",
        "text": "Ich liebe, wie einfach es ist, ein Spiel zu finden. Die Oberfläche ist schön und intuitiv."
      },
      "3": {
        "name": "Hans K.",
        "role": "Clubmeister",
        "text": "Endlich eine Plattform, die internationales Dame ernst nimmt. Sehr empfehlenswert!"
      },
      "title": "Was Spieler Sagen"
    },
    "cta": {
      "title": "Bereit zu Spielen?",
      "subtitle": "Schließe dich Tausenden von Spielern an und beginne heute deine Dame-Reise.",
      "button": "Jetzt Spielen"
    },
    "footer": {
      "tagline": "Die führende Online-Dame-Plattform",
      "game": "Spiel",
      "playNow": "Jetzt Spielen",
      "tournaments": "Turniere",
      "leaderboard": "Rangliste",
      "puzzles": "Rätsel",
      "learn": "Lernen",
      "tutorial": "Tutorial",
      "strategies": "Strategien",
      "rules": "Regeln",
      "videos": "Videos",
      "community": "Community",
      "forum": "Forum",
      "clubs": "Clubs",
      "blog": "Blog",
      "discord": "Discord",
      "rights": "Alle Rechte vorbehalten."
    }
  },
  "arena": {
    "title": "Arena",
    "subtitle": "Schnelles Dauerspiel",
    "ending": "Endet...",
    "status": {
      "live": "LIVE",
      "upcoming": "KOMMEND",
      "finished": "BEENDET"
    },
    "card": {
      "yourPlace": "du {{rank}}."
    },
    "actions": {
      "join": "Arena Beitreten",
      "leave": "Arena Verlassen",
      "play": "Spielen",
      "pause": "Pause",
      "resume": "Weiterspielen",
      "boost": "Boost",
      "backToGame": "Zurück zur Partie",
      "retry": "Erneut"
    },
    "errors": {
      "authRequired": "Du musst angemeldet sein, um einer Arena beizutreten.",
      "guestNotAllowed": "Gäste können keiner Arena beitreten. Lege ein Konto an, um deine Partien zu behalten.",
      "notAllowed": "Dieses Konto kann keiner Arena beitreten.",
      "arenaNotFound": "Diese Arena gibt es nicht mehr.",
      "userNotFound": "Wir finden dein Konto nicht. Melde dich bitte erneut an.",
      "invalidInput": "Die Anfrage war ungültig. Lade die Seite neu und versuche es erneut.",
      "rateLimited": "Zu viele Versuche. Warte bitte ein paar Sekunden und versuche es erneut.",
      "ratingTooLow": "Deine Wertung liegt unter dem Minimum dieser Arena.",
      "joinFailed": "Du konntest der Arena nicht beitreten. Bitte versuche es erneut.",
      "arenaPiena": "Diese Arena ist voll: es sind keine Plätze mehr frei.",
      "arenaChiusa": "Diese Arena nimmt keine Anmeldungen mehr an.",
      "giaIscritto": "Du bist bereits in dieser Arena.",
      "arenaScaduta": "Die Zeit dieser Arena ist abgelaufen: es wird nur noch auf das Ende der letzten Partien gewartet.",
      "arenaAnnullata": "Diese Arena wurde abgesagt.",
      "arenaAnnullataPochiIscritti": "Diese Arena wurde abgesagt: zur Startzeit waren zu wenige Spieler angemeldet.",
      "arenaAnnullataDaOrganizzatore": "Wer diese Arena eröffnet hat, hat sie wieder abgesagt.",
      "notOrganizer": "Das kann nur, wer die Arena eröffnet hat.",
      "alreadyStarted": "Die Arena läuft bereits.",
      "giaInUnArena": "Du bist bereits in einer laufenden Arena: verlasse sie, um hier zu spielen",
      "leaveFailed": "Du konntest die Arena nicht verlassen. Bitte versuche es erneut.",
      "notInArena": "Du bist bei dieser Arena nicht dabei.",
      "notInGame": "Du spielst diese Partie nicht.",
      "gameNotFound": "Diese Partie gibt es nicht mehr.",
      "tooLate": "Zu spät: Der Boost lässt sich nur vor dem ersten Zug ändern.",
      "boostDisabled": "In dieser Arena ist der Boost ausgeschaltet.",
      "alreadyBoosted": "Der Boost ist in dieser Partie bereits aktiv.",
      "notBoosted": "Der Boost ist in dieser Partie nicht aktiv.",
      "boostFailed": "Der Boost konnte nicht eingeschaltet werden. Bitte versuche es erneut.",
      "unboostFailed": "Der Boost konnte nicht ausgeschaltet werden. Bitte versuche es erneut.",
      "serverError": "Bei uns ist etwas schiefgelaufen. Bitte versuche es erneut.",
      "offline": "Keine Verbindung zum Server.",
      "timeout": "Der Server hat nicht geantwortet. Bitte versuche es erneut.",
      "unknown": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      "notYourTurn": "Du bist nicht am Zug.",
      "drawOfferFailed": "Wir konnten dein Remisangebot nicht senden. Versuch es noch einmal.",
      "moveRejected": "Der Server hat deinen Zug abgelehnt: Das Brett steht wieder wie zuvor."
    },
    "standings": {
      "search": "Spieler suchen",
      "searchEmpty": "Kein Spieler mit diesem Namen.",
      "sheetHint": "Alle Partien, neueste rechts · Gold = Bonus",
      "loadMore": "Mehr anzeigen",
      "sheet": "Partien",
      "toClimb_one": "{{count}} Punkt zum Aufstieg",
      "toClimb_other": "{{count}} Punkte zum Aufstieg",
      "lead_one": "{{count}} Punkt Vorsprung",
      "lead_other": "{{count}} Punkte Vorsprung",
      "boostOn": "Boost aktiv",
      "searchScope": "Die Suche sieht nur die bereits geladenen Zeilen: Lade die übrigen, um alle zu durchsuchen.",
      "justPlayedHint": "Das Zeichen ↺: Du hast gerade gegen diese Person gespielt — daneben steht, wie lange es noch dauert, bis sie wieder zugelost werden kann.",
      "justPlayedIn": "Bereits gespielt: wieder verfügbar in {{time}}"
    },
    "info": {
      "details": "Details",
      "scoring": "Punktesystem",
      "loss": "Niederlage: {{points}}",
      "boostTitle": "Boost ⚡",
      "boostTimeCost": "Nimmt dir das Inkrement und halbiert deine Grundzeit",
      "boostExtraPoint": "Verdoppelt deine Siegpunkte bei Gewinn",
      "boostBeforeFirst": "Bis zu deinem ersten Zug ein- und ausschaltbar"
    },
    "matchFound": {
      "title": "Gegner Gefunden",
      "opponent": "Gegner",
      "playAsWhite": "Du spielst mit Weiß",
      "playAsBlack": "Du spielst mit Schwarz",
      "startingIn": "Start in",
      "startNow": "Jetzt Starten"
    },
    "gameEnd": {
      "win": "Sieg",
      "loss": "Niederlage",
      "draw": "Remis",
      "pointsEarned": "Erzielte Punkte",
      "basePoints": "Basispunkte",
      "boostBonus": "Boostbonus",
      "total": "Gesamt",
      "pointsVoided": "Partie nicht gewertet: keine Punkte für beide Spieler",
      "rank": "Rang",
      "totalPoints": "Punkte",
      "paused": "Du bist pausiert: setze fort, wann du willst.",
      "arenaFinished": "Arena beendet",
      "arenaDraining": "Zeit abgelaufen: die Arena schließt, sobald die letzten Partien enden.",
      "analyze": "Analysieren",
      "pause": "Pausiert",
      "playNext": "Weiter",
      "backToArena": "Zurück zur Arena",
      "resumeFailed": "Wir konnten dich nicht zurück in die Warteschlange setzen: Prüfe deine Verbindung und versuch es erneut.",
      "returnLegIn_one": "Rückspiel in {{count}} Sekunde…",
      "returnLegIn_other": "Rückspiel in {{count}} Sekunden…"
    },
    "game": {
      "boost": "Boost",
      "boostRemove": "Entfernen",
      "boostRetry": "Erneut"
    },
    "confirmBoost": {
      "title": "Boost aktivieren?",
      "halve": "Deine Grundzeit geht von {{prima}} auf {{dopo}} und du verlierst das Inkrement von {{incremento}}s.",
      "halveOnly": "Deine Grundzeit geht von {{prima}} auf {{dopo}}.",
      "reward": "Wenn du gewinnst, zählen die Punkte doppelt. Du kannst ihn bis zu deinem ersten Zug entfernen.",
      "confirm": "Aktivieren"
    },
    "results": {
      "arenaFinished": "Arena Beendet",
      "yourPosition": "Deine Position",
      "outOf_one": "von {{count}} Spieler",
      "outOf_other": "von {{count}} Spielern",
      "yourStats": "Deine Statistiken",
      "totalPoints": "Gesamtpunkte",
      "gamesPlayed": "Gespielte Partien",
      "games": "Partien",
      "wins": "Siege",
      "draws": "Remis",
      "losses": "Niederlagen",
      "winRate": "Siegquote",
      "boostUsed": "Boosts verwendet",
      "share": "Teilen",
      "nextArena": "Nächste Arena",
      "unavailable": "Uns liegen die Ergebnisse dieser Arena nicht vor.",
      "unavailableSub": "Geh zurück zur Liste und öffne sie erneut im Reiter „Beendet“."
    },
    "tabs": {
      "rules": "Regeln"
    },
    "signInToJoin": "Melde dich an, um Arenen beizutreten",
    "positionCta": "Tritt bei und kämpfe um die Spitze der Rangliste!",
    "band": {
      "searchingTitle": "Ich suche einen Gegner",
      "searchingSub": "Sobald ich eine Paarung finde, bringe ich dich ins Spiel.",
      "drainingTitle": "Die Zeit ist um",
      "drainingSub": "Ich paare niemanden mehr: sobald die letzten Partien enden, kommt die Endtabelle.",
      "pausedTitle": "Du pausierst",
      "pausedSub": "Bis du fortsetzt, wirst du mit niemandem gepaart.",
      "pausedAwaySub": "Ich habe dich pausiert, weil die App im Hintergrund war. Setze fort, wann du willst.",
      "pausedOfflineSub": "Du wurdest pausiert, weil du beim Start der Arena offline warst.",
      "pausedOtherArenaSub": "Du spielst in der anderen Arena. Wenn du dort fertig bist, drücke Fortsetzen, um hier wieder in die Warteschlange zu kommen.",
      "playingTitle": "Du bist in einer Partie",
      "playingSub": "Die Partie läuft noch: geh zurück.",
      "playingSubVs": "Gegen {{opponent}} · mit {{color}}.",
      "waitingTitle": "Du bist dabei",
      "waitingSub": "Die Arena hat noch nicht begonnen.",
      "joinTitle": "Du bist nicht dabei",
      "joinSub": "Mach mit, ich paare dich mit den Wartenden."
    },
    "timebar": {
      "endsIn": "Endet in"
    },
    "games": {
      "mine": "Meine",
      "deletedPlayer": "Gelöschter Spieler",
      "loadFailed": "Wir konnten die Partien nicht laden."
    },
    "a11y": {
      "scoreUpdate": "Jetzt {{points}} Punkte, Platz {{rank}}"
    },
    "spotlight": {
      "eyebrow": "Arena",
      "daysHours": "{{days}}T {{hours}}Std",
      "startsIn": "Beginnt in",
      "yourResult": "Du wurdest {{rank}}.",
      "review": "Schau, wie es lief"
    },
    "twoLeg": "Hin- und Rückspiel",
    "noBoost": "Ohne Boost",
    "share": {
      "title": "Dame-Arena",
      "text": "Du bist zur Arena {{nome}} auf draughtsgame.com eingeladen"
    },
    "detail": {
      "askPassword": "Arena-Passwort",
      "share": "Einladung teilen",
      "shareCopied": "Link kopiert",
      "cancelArena": "Arena absagen",
      "cancelConfirm": "Die Arena verschwindet und alle Angemeldeten werden benachrichtigt. Das lässt sich nicht rückgängig machen."
    }
  },
  "specialEvent": {
    "eyebrow": "Besonderes Event",
    "badge": "Besonders",
    "organizedBy": "Organisiert von Draughts Game"
  },
  "legal": {
    "termsTitle": "AGB",
    "privacyTitle": "Datenschutz",
    "acceptTerms": "Ich akzeptiere die <terms>Nutzungsbedingungen</terms> und die <privacy>Datenschutzerklärung</privacy>",
    "acceptTermsOnly": "Ich akzeptiere die <terms>Nutzungsbedingungen</terms>",
    "acceptPrivacyOnly": "Ich akzeptiere die <privacy>Datenschutzerklärung</privacy>",
    "ageConfirm": "Ich bestätige, dass ich mindestens 16 Jahre alt bin",
    "acceptRequired": "Du musst die Nutzungsbedingungen akzeptieren",
    "acceptTermsRequired": "Kreuze das Kästchen an, um die Nutzungsbedingungen zu akzeptieren",
    "acceptPrivacyRequired": "Kreuze das Kästchen an, um die Datenschutzerklärung zu akzeptieren",
    "ageRequired": "Kreuze das Kästchen an, um dein Alter zu bestätigen",
    "lastUpdated": "Zuletzt aktualisiert",
    "subtitle": "Deine Rechte und unsere Verpflichtungen",
    "missingConsents_one": "Noch {{count}} Häkchen oben",
    "missingConsents_other": "Noch {{count}} Häkchen oben"
  },
  "cookies": {
    "message": "Wir verwenden essenzielle Cookies, damit die Seite funktioniert. Wenn du zustimmst, nutzen wir außerdem Messwerkzeuge — Umami, um zu sehen, wie die Seite genutzt wird, und Sentry, um Fehler zu bemerken. Du kannst ablehnen: die Seite funktioniert genauso.",
    "acceptAll": "Alle akzeptieren",
    "rejectAnalytics": "Nur essenzielle"
  },
  "puzzle": {
    "toPlayAndWin": "zieht und gewinnt",
    "black": "Schwarz",
    "white": "Weiß",
    "dashboard": "Dashboard",
    "hint": "Tipp",
    "hintTip": "Ein Tipp kostet nur die Wertung: Dieses Puzzle wird ungewertet, du gewinnst und verlierst keine Punkte. Es zählt weiterhin als gelöst und erhält deinen Streak.",
    "solution": "Lösung",
    "solutionTip": "Die Lösung anzuzeigen zählt als fehlgeschlagener Versuch: Du verlierst Wertungspunkte, aber der Tag zählt trotzdem für deinen Streak.",
    "continueVsAI": "Gegen KI weiterspielen",
    "playAgain": "Nochmal spielen",
    "back": "Zurück",
    "forward": "Vor",
    "puzzleRating": "Puzzle-Wertung",
    "ratingChange": "Wertung",
    "newRating": "jetzt",
    "yourRating": "Deine Wertung",
    "solutionMoves": "Lösung",
    "moves": "Züge",
    "motifs": "Motive",
    "motifsRevealed": "sichtbar",
    "motifsHidden": "nach dem Lösen sichtbar",
    "result": {
      "solvedEyebrow": "Gelöst",
      "failedEyebrow": "Lösung",
      "nice": "Gut",
      "solving": "gelöst.",
      "theLine": "Hier ist die",
      "line": "Lösung."
    },
    "title": "Rätsel",
    "loading": "Puzzle wird geladen…",
    "yourTurn": "Finde den besten Zug!",
    "correct": "Richtig!",
    "incorrect": "Nicht ganz",
    "solved": "Rätsel gelöst!",
    "failed": "Rätsel fehlgeschlagen",
    "giveUp": "Aufgeben",
    "nextPuzzle": "Nächstes Rätsel",
    "backToHome": "Zurück zur Startseite",
    "rating": "Rating",
    "daily": "Tagesrätsel",
    "practice": "Üben",
    "share": "Teilen",
    "solve": "Lösen",
    "demo": {
      "badge": "Demo-Rätsel",
      "solvedTitle": "Stark – gelöst!",
      "trainTitle": "Jeden Tag trainieren?",
      "registerPitch": "Kostenloses Konto erstellen: jeden Tag ein neues Rätsel, für jede Variante ein eigenes.",
      "registerCta": "Kostenloses Konto erstellen"
    },
    "retry": "Wiederholen",
    "shareTitle": "Tagesrätsel",
    "shareText": "Ich habe das heutige Tagesrätsel gelöst — schaffst du es auch?",
    "shareCopied": "Link kopiert!",
    "unavailable": {
      "title": "Dieses Puzzle ist nicht verfügbar",
      "link": "Das heutige Puzzle konnte nicht geöffnet werden. Vielleicht gibt es für diese Variante keines, oder die Verbindung ist abgebrochen.",
      "session": "Dieses Puzzle konnte nicht gestartet werden. Prüfe deine Verbindung und versuche es erneut.",
      "home": "Zur Startseite"
    },
    "invite": {
      "title": "Das Rätsel von heute wartet auf dich",
      "body": "Ein Freund hat das Rätsel von heute mit dir geteilt. Die täglichen Rätsel sind registrierten Spielern vorbehalten — erstelle ein kostenloses Konto oder melde dich an, um das Brett freizuschalten.",
      "locked": "Vorschau gesperrt",
      "tryDemo": "Probiere solange das Demo-Rätsel",
      "moves_one": "{{count}} Zug",
      "moves_other": "{{count}} Züge"
    },
    "guest": {
      "locked": "Daily Puzzles sind registrierten Spielern vorbehalten. Melde dich an oder erstelle ein kostenloses Konto, um sie zu spielen."
    },
    "networkError": "Netzwerkproblem: der Zug wurde nicht erfasst. Bitte erneut versuchen."
  },
  "dashboard": {
    "hero": {
      "welcome": "Willkommen zurück",
      "settings": "Einstellungen",
      "ctaPlayNow": "Jetzt spielen",
      "ctaVsComputer": "Gegen KI",
      "moreVariants": "Weitere Varianten ({{count}})",
      "logoutConfirmTitle": "Abmelden?",
      "logoutConfirmBody": "Du wirst auf diesem Gerät von deinem Konto abgemeldet.",
      "ctaDailyPuzzle": "Tagesaufgaben",
      "themeDark": "Zum dunklen Design wechseln",
      "themeLight": "Zum hellen Design wechseln",
      "ratingDeltaUp": "{{points}} Punkte mehr in den letzten 7 Tagen",
      "ratingDeltaDown": "{{points}} Punkte weniger in den letzten 7 Tagen"
    },
    "notif": {
      "challengedYou": "<b>{{name}}</b> ({{rating}}) hat dich zu <b>{{timeControl}}</b> · {{variant}} herausgefordert",
      "challengedYouNoRating": "<b>{{name}}</b> hat dich zu <b>{{timeControl}}</b> · {{variant}} herausgefordert",
      "accept": "Annehmen",
      "decline": "Ablehnen"
    },
    "streak": {
      "daysInRow_one": "{{count}} Tag in Folge",
      "daysInRow_other": "{{count}} Tage in Folge",
      "unitLabel_one": "Tag in Folge",
      "unitLabel_other": "Tage in Folge",
      "record": "Rekord zu knacken: <b>{{count}} Tage</b>",
      "recordTying": "Rekord eingestellt: <b>{{count}} Tage</b>",
      "empty": "Starte heute",
      "solvePuzzle": "Ein Problem lösen",
      "doneToday": "Für heute erledigt 🔥",
      "keepHint": "Spiele oder löse ein Problem, um deinen Streak zu halten.",
      "last7DaysLabel": "Aktivität der letzten 7 Tage"
    },
    "dailyGoal": {
      "title": "Tagesziel",
      "label": "Partien",
      "remaining_one": "<b>Noch eine</b> bis zum Ziel",
      "remaining_other": "<b>Noch {{count}}</b> bis zum Ziel",
      "done": "Ziel erreicht",
      "targetLabel": "Partien pro Tag",
      "editGoal": "Ziel bearbeiten"
    },
    "activity": {
      "title": "Aktivität",
      "last3Months": "Letzte 3 Monate",
      "centerGames": "Partien",
      "statsGames_one": "{{count}} Partie",
      "statsGames_other": "{{count}} Partien",
      "statsActiveDays_one": "{{count}} aktiver Tag",
      "statsActiveDays_other": "{{count}} aktive Tage",
      "statsPerDay": "{{value}} Partien/Tag",
      "empty": "Deine Partien erscheinen hier",
      "statsTotalTime": "{{value}} insgesamt",
      "tooltipToday": "Heute",
      "tooltipYesterday": "Gestern",
      "legendBucket0": "0",
      "legendBucket1": "1-2",
      "legendBucket2": "3-5",
      "legendBucket3": "6-9",
      "legendBucket4": "10+",
      "duration": {
        "zero": "0 min",
        "minutes_one": "{{count}} min",
        "minutes_other": "{{count}} min",
        "hours_one": "{{count}}h",
        "hours_other": "{{count}}h",
        "hoursMinutes": "{{hours}}h {{minutes}}m"
      },
      "dayMon": "Mo",
      "dayThu": "Do",
      "daySat": "Sa",
      "dayTue": "Di",
      "dayWed": "Mi",
      "dayFri": "Fr",
      "daySun": "So"
    },
    "recentGames": {
      "title": "Letzte Partien",
      "viewAll": "Alle im Profil →",
      "replay": "Wiedergeben",
      "empty": "Noch keine Partien"
    },
    "upcomingTournaments": {
      "title": "Aktive Turniere",
      "viewAll": "Alle →",
      "viewAllAria": "Alle Turniere ansehen",
      "empty": "Keine Turniere geplant"
    },
    "liveEvent": {
      "emptyTitle": "Turniere & Arenen",
      "empty": "Keine laufenden Events",
      "nextAt": "Nächstes Daily startet um {{time}}",
      "minutesLeft_one": "Endet in {{count}} Minute",
      "minutesLeft_other": "Endet in {{count}} Minuten",
      "participants_one": "{{count}} Spieler",
      "participants_other": "{{count}} Spieler"
    },
    "puzzle": {
      "titleWhiteToMove": "Weiß am Zug\nund gewinnt",
      "titleBlackToMove": "Schwarz am Zug\nund gewinnt",
      "meta": "Finde die beste Zugfolge",
      "cta": "Lösen →",
      "viewAll": "Alle →",
      "tag": {
        "tactic": "Taktik"
      },
      "solvedNext": "Gelöst ✓ · Komm morgen für das nächste zurück",
      "tryInternational": "Probier ein International-Puzzle →",
      "overlayTitle": "Tagesaufgaben"
    },
    "avvisoDati": {
      "offline": "Du scheinst offline zu sein — deine Daten wurden nicht geladen.",
      "server": "Deine Daten konnten nicht geladen werden.",
      "inCorso": "Erneuter Versuch…",
      "ricarica": "Neu laden"
    },
    "installCard": {
      "eyebrow": "App",
      "title": "Draughts Game installieren",
      "benefit": "Füge sie zum Startbildschirm hinzu: Sie öffnet sich im Vollbild, startet schneller und liegt neben deinen anderen Apps.",
      "howTo": "Wie geht das?",
      "choose": "Wähle dein Gerät:",
      "os": {
        "android": "Android",
        "ios": "iPhone oder iPad",
        "desktop": "Computer"
      }
    }
  },
  "pwa": {
    "openInAppText": "Du bist im Browser von WhatsApp. Öffne den Link außerhalb, um die App vollständig zu nutzen.",
    "openInAppCta": "In der App öffnen",
    "openInBrowserText": "Du bist im Browser von WhatsApp. Öffne den Link in Safari für die vollständige App.",
    "iosHint": "Tippe unten rechts auf ••• und dann auf „In Safari öffnen“.",
    "installText": "Installiere Draughts Game und spiele vom Startbildschirm aus.",
    "installCta": "App installieren",
    "copyLink": "Link kopieren",
    "linkCopied": "Link kopiert!",
    "dismiss": "Schließen"
  },
  "seo": {
    "breadcrumbHome": "Startseite",
    "landing": {
      "title": "Draughts Game — Dame online kostenlos spielen",
      "description": "Dame online kostenlos spielen: international, italienisch, türkisch, friesisch und 20 weitere Varianten. Mehrspieler in Echtzeit, gewertete Partien, Turniere, KI-Gegner und täglich ein neues Problem."
    },
    "faq": {
      "title": "Häufige Fragen — Dame online spielen",
      "description": "Antworten zu Konten, Wertung, Turnieren, App-Installation und Partien im Netz, dazu ein direkter Draht für Meldungen und Vorschläge."
    },
    "terms": {
      "title": "Nutzungsbedingungen — Draughts Game",
      "description": "Die Bedingungen für die Nutzung von Draughts Game: Konten, faires Spiel, Wertung, Inhalte und die Regeln, denen beide Seiten zustimmen."
    },
    "privacy": {
      "title": "Datenschutzerklärung — Draughts Game",
      "description": "Welche Daten Draughts Game erhebt, warum, wie lange sie gespeichert werden und welche Rechte Sie nach der DSGVO daran haben."
    }
  }
}
